var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 639.334,
    height: 533.368,
    viewBox: "0 0 639.334 533.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M237.861-112.975a7.518,7.518,0,0,1-2-1.757,7.28,7.28,0,0,0,2.005,1.724.268.268,0,0,1,0,.033m-2.007-1.761a.246.246,0,0,0-.017-.021.247.247,0,0,1,.017.021m8.6-3.785A22.583,22.583,0,0,0,246.1-120.2a4.067,4.067,0,0,0,.239,1.208l-1.883.473m14.6-21.523a31.728,31.728,0,0,0-4.531-1.309l.965-2.387a10.763,10.763,0,0,0-1.4-4.2l-.627.979a11.569,11.569,0,0,0-2.088-4.236c-.177-.012-.357-.019-.539-.019a10.435,10.435,0,0,0-5.543,1.828,16.7,16.7,0,0,0-1.435,1.027h0a16.7,16.7,0,0,1,1.435-1.027,10.435,10.435,0,0,1,5.543-1.828c.181,0,.361.007.539.019,4.253.3,7.342,4.381,7.681,11.153",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(0 -0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M93.632-315.06c-124.84,72.074-124.843,188.93-.007,261s327.239,72.074,452.078,0,124.842-188.93.007-261-327.237-72.074-452.078,0",
    transform: "translate(0 533.387)",
    fill: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M639.321-182.929c-.7,46.695-31.911,93.255-93.62,128.88S403.326-.416,322.456-.024C274.2.233,225.868-5.8,181.435-18.1L608.021-264.34c21.287,25.651,31.722,53.552,31.3,81.411",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M608.021-264.34,181.435-18.1C225.868-5.8,274.2.233,322.456-.024c80.87-.392,161.536-18.4,223.245-54.025s92.916-82.185,93.62-128.88c.421-27.859-10.013-55.76-31.3-81.411",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M219.064-39.82,215.3-37.646,277.738-1.595q4.268.324,8.545.584l-67.22-38.81",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M574.188-244.811l62.388,36.02q-.582-2.552-1.288-5.093l-57.333-33.1-3.767,2.175",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M545.721-54.061c1.259-.727,2.485-1.466,3.72-2.2L398.51-143.4l-3.768,2.175L545.721-54.061",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M437.482-12.96q2.69-.614,5.363-1.254l-134.058-77.4-3.768,2.175L437.482-12.96",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M616.91-116.553q1.074-1.563,2.1-3.137l-130.775-75.5-3.768,2.175L616.91-116.553",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M322.456-.024l316.865-182.9c-.7,46.695-31.911,93.255-93.62,128.88S403.326-.416,322.456-.024",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M322.456-.024l316.865-182.9c-.7,46.695-31.911,93.255-93.62,128.88S403.326-.416,322.456-.024",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M4.185-154.764C14.577-117.892,44.379-82.489,93.625-54.056a348.566,348.566,0,0,0,49.588,23.43L586.395-286.344a258.574,258.574,0,0,0-40.686-28.717c-49.2-28.406-110.449-45.607-174.249-51.623L4.185-154.764",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M173.113-423.528l-.192-.184a13.584,13.584,0,0,0-16.31-4.82c-1.085-4.413-6.423-8.242-12.3-6.952.2-5.733-7.118-11.9-13.7-13.3-6.308-1.343-11.807-.779-15.407,3.369-3.852-7.524-18.956-9.644-27.129-5.664-4.7,2.291-8.688,4.639-10.637,8.946a17.959,17.959,0,0,0-1.77,8.562c-3.185-2.808-9.563-3.567-13.817-1.921-4.587,1.773-4.935,5.231-5.161,8.748a16.039,16.039,0,0,0-8.35-.151,5.914,5.914,0,0,0-4.012,3.361H173.113",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M162.092-498.32l.216-.208a15.363,15.363,0,0,1,18.445-5.451c1.225-4.991,7.262-9.321,13.909-7.862-.228-6.483,8.05-13.449,15.489-15.033,7.133-1.519,13.352-.88,17.422,3.811,4.356-8.509,21.435-10.906,30.678-6.405,5.315,2.588,9.824,5.245,12.028,10.116a20.3,20.3,0,0,1,2,9.682c3.6-3.175,10.814-4.033,15.625-2.172,5.187,2.005,5.581,5.916,5.837,9.892a18.146,18.146,0,0,1,9.441-.171,6.687,6.687,0,0,1,4.537,3.8H162.092",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M173.113-423.528H44.33a5.914,5.914,0,0,1,4.012-3.361,12.9,12.9,0,0,1,3.627-.464,19.356,19.356,0,0,1,4.723.615c.227-3.517.575-6.975,5.161-8.748a14.157,14.157,0,0,1,5.039-.86c3.3,0,6.712.96,8.778,2.781a17.958,17.958,0,0,1,1.77-8.562c1.949-4.308,5.936-6.656,10.637-8.946a22.86,22.86,0,0,1,9.784-1.972c7.189,0,14.773,2.615,17.344,7.636,2.485-2.863,5.873-4.017,9.809-4.017a27.077,27.077,0,0,1,5.6.648c6.488,1.381,13.7,7.394,13.7,13.06q0,.118,0,.236h0a10.8,10.8,0,0,1,2.324-.255c4.908,0,9.037,3.385,9.977,7.207a13.679,13.679,0,0,1,5.187-.993,13.268,13.268,0,0,1,11.124,5.813l.192.184",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M307.72-498.32H162.092l.216-.208a15.008,15.008,0,0,1,12.58-6.573,15.474,15.474,0,0,1,5.865,1.123c1.061-4.321,5.732-8.149,11.281-8.149a12.289,12.289,0,0,1,2.628.287h0c0-.088-.005-.177-.005-.265,0-6.407,8.157-13.206,15.494-14.768a30.6,30.6,0,0,1,6.331-.733c4.451,0,8.282,1.305,11.092,4.544,2.908-5.679,11.484-8.636,19.613-8.636a25.829,25.829,0,0,1,11.065,2.231c5.315,2.588,9.824,5.245,12.028,10.116a20.3,20.3,0,0,1,2,9.682c2.337-2.059,6.193-3.144,9.928-3.144a16,16,0,0,1,5.7.972c5.187,2.005,5.581,5.916,5.837,9.892a21.842,21.842,0,0,1,5.34-.695,14.617,14.617,0,0,1,4.1.524,6.687,6.687,0,0,1,4.537,3.8",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M216.128-80.869c11.822,6.826,11.822,17.893,0,24.72s-30.993,6.826-42.816,0-11.822-17.893,0-24.72,30.993-6.826,42.816,0",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M247.544-56.26A26.223,26.223,0,0,1,241-58.867c-8.562-4.943-8.562-12.958,0-17.9a27.068,27.068,0,0,1,7.685-2.879c.063.635.133,1.34.217,2.148.185,1.767.248,2.606.393,4.3s-1.188,3.767-3.391,5.006c-1.936,1.088-3.3,1.237-4.357,2.356-.987,1.048.756,2.2,1.653,2.363a13.285,13.285,0,0,0,2.393.316,5.735,5.735,0,0,0,1.383-.167,6.912,6.912,0,0,0,3.035-1.449,6.5,6.5,0,0,1,2.908-1.606c1.209-.336,2.736-.584,2.709-1.21-.024-.573.007-2.78-.075-3.324a17.829,17.829,0,0,0-.507-2.429,54.835,54.835,0,0,1,.984-7.132l.473,0c1.037,0,2.073.043,3.1.127a6.473,6.473,0,0,1,.637,2.887,8.07,8.07,0,0,1-.113,1.345c-.321,1.889-.928,2.99-.927,4.248a3.958,3.958,0,0,0,.035.51.937.937,0,0,0,1.048.847,3.064,3.064,0,0,0,1.764-.649,8.086,8.086,0,0,0,2.435-2.776,6.981,6.981,0,0,0,.772-2.945c0-.083,0-.167-.005-.249-.009-.181-.016-.357-.016-.532a5.914,5.914,0,0,1,.236-1.708,26.179,26.179,0,0,1,6.537,2.6,15.343,15.343,0,0,1,4.516,3.78L247.544-56.26",
    transform: "translate(0 533.387)",
    fill: "#d4d6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M256.507-55.158a36.1,36.1,0,0,1-8.962-1.1l28.982-16.729c3.6,4.652,2.1,10.3-4.516,14.122a31.687,31.687,0,0,1-15.5,3.708",
    transform: "translate(0 533.387)",
    fill: "#cacbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M347.07-81.631q-.91,0-1.873-.069c-5.275-.1-12.734-3.545-8.461-8.836,8.2-7.685,20.467-6.423,29.9-12.451,3.412-2.021,6.713-5.36,10.276-7.082a21.031,21.031,0,0,1,8.2-1.995,12.12,12.12,0,0,1,3.993.655,3.423,3.423,0,0,1,2.651,3.528c-.1,5.408-9.834,8.468-14.156,10.437-11.7,4.511-16.864,15.813-30.537,15.813",
    transform: "translate(0 533.387)",
    fill: "#cacbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M491.444-197.048a31.985,31.985,0,0,1-7.909-3.16c-10.452-6.035-10.452-15.818,0-21.853a33.245,33.245,0,0,1,9.712-3.585,3.19,3.19,0,0,0,1.045.184c.077,0,.153,0,.231-.009a1.4,1.4,0,0,0,1.14-.605l0-.007a45.385,45.385,0,0,1,5.8-.492c.312,2.479.532,4,.532,4l.029.008a24.681,24.681,0,0,1,.185,4.467c-.147.549-.547,1.419-.339,1.852.28.581.764.86,1.42,1.684a29.251,29.251,0,0,0,2.424,2.7,8.35,8.35,0,0,0,2.68,1.721,8.215,8.215,0,0,0,3.091.744,4.26,4.26,0,0,0,.847-.083c.457-.095,1.48-.316,1.579-.757a1.387,1.387,0,0,0-.3-.98c-1.183-1.949-1.341-2.136-2.479-4.109-1.475-2.56-1.033-3.632-.947-5.412.032-.648.069-1.261.111-1.855.093-.039.185-.079.276-.123,0,0,.135-1.175.348-3.083a33.745,33.745,0,0,1,10.462,3.736,18.781,18.781,0,0,1,5.476,4.569l-35.416,20.443",
    transform: "translate(0 533.387)",
    fill: "#d4d6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M502.459-195.683a44.017,44.017,0,0,1-11.016-1.365l35.416-20.443c4.444,5.688,2.619,12.609-5.476,17.284-5.227,3.017-12.076,4.525-18.925,4.525",
    transform: "translate(0 533.387)",
    fill: "#cacbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M605.935-430.259V-249.34l2.288-1.319V-431.625l-2.288,1.367",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M602.821-432.1v180.962l3.115,1.8V-430.259l-3.115-1.845",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "M602.821-432.1l3.115,1.845,2.288-1.365-3.115-1.8-2.288,1.319",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M617.806-416.356l-28.35-16.368c-1.052-.608-1.905-.116-1.905,1.1v48.907a4.211,4.211,0,0,0,1.905,3.3l28.35,16.368c1.052.608,1.9.115,1.9-1.1v-48.905a4.213,4.213,0,0,0-1.905-3.3",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M618.657-362.792a1.731,1.731,0,0,1-.851-.26l-11.87-6.853-3.115-1.8-13.365-7.717a4.211,4.211,0,0,1-1.905-3.3v-48.907c0-.861.429-1.359,1.055-1.359a1.721,1.721,0,0,1,.851.26l28.35,16.368a4.213,4.213,0,0,1,1.905,3.3v48.905c0,.863-.429,1.36-1.053,1.36",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M589.224-430.935l-.008,48.216a2.568,2.568,0,0,0,1.071,1.856l27.751,16.022.008-48.216a2.568,2.568,0,0,0-1.072-1.857Zm.832,1.44,26.5,15.3a1.829,1.829,0,0,1,.656,1.137l-.008,46.775-26.5-15.3a1.818,1.818,0,0,1-.655-1.135l.008-46.776",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "M599.153-401.969a1.963,1.963,0,0,1-.8-1.044l10.556,6.1c-.144.259-.447.323-.8.12Zm12.624,3.641c0,.639-.448.9-1,.577a2.213,2.213,0,0,1-1-1.733c0-.639.449-.9,1-.579A2.214,2.214,0,0,1,611.777-398.327Zm-.748-3.94c0,.187-.131.261-.292.168l-6.8-3.927v-6.763l5.193,3a4.2,4.2,0,0,1,1.9,3.293Zm0-8.254c0,.4-.28.56-.624.36a1.377,1.377,0,0,1-.624-1.08c0-.4.279-.56.624-.36A1.38,1.38,0,0,1,611.029-410.522Zm-2.581-.88-.143.084-9.346-5.4-.145-.249v-1.219l.145-.084,9.346,5.4.143.251Zm-10.188,6.008,10.742,6.2v.5l-10.742-6.2ZM609-400.439v.581l-10.742-6.2v-.583ZM598.26-404.23l10.742,6.2v.5l-10.742-6.2Zm-.125-11.906,5.193,3v6.763l-6.8-3.927a.645.645,0,0,1-.291-.505v-4.231C596.234-416.251,597.085-416.743,598.134-416.136Zm-.652-2.207c0,.4-.28.56-.624.36a1.377,1.377,0,0,1-.624-1.08c0-.4.279-.56.624-.36A1.38,1.38,0,0,1,597.482-418.343Zm-1,10.03a2.217,2.217,0,0,1,1,1.735c0,.639-.449.9-1,.579a2.214,2.214,0,0,1-1-1.735C595.485-408.372,595.933-408.631,596.486-408.312Zm-3.68-7.3v2.473a1.326,1.326,0,0,0,.6,1.039l.313.181v.735a1.249,1.249,0,0,0,.564.976l.515.3v6.1l-.068-.04c-.359-.207-.648-.039-.648.375v.216a3.437,3.437,0,0,0,1.555,2.693l.321.185v1.576a.928.928,0,0,0,.42.728l2.015,1.164c.232.133.42.024.42-.244v-1.576l9.634,5.563v1.576a.934.934,0,0,0,.421.729l2.015,1.163c.232.133.42.025.42-.243v-1.576l.321.185c.859.5,1.555.093,1.555-.9v-.215a1.431,1.431,0,0,0-.648-1.123l-.068-.04v-6.1l.515.3c.311.18.564.035.564-.325v-.733l.313.18c.331.191.6.036.6-.347v-2.473l-.163-.281-1.164-.672-.161.093v2.7h0v1.2l-.5-.3v-8.641a5.3,5.3,0,0,0-2.4-4.149L597.194-420.6c-1.323-.764-2.4-.144-2.4,1.383v8.642l-.5-.283v-1.2h0v-2.7l-.163-.28-1.164-.672-.163.093",
    transform: "translate(0 533.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M594.454-385.537c.145.084.251.072.32-.035a1.4,1.4,0,0,0,.1-.66,2.159,2.159,0,0,0-.1-.741.739.739,0,0,0-.323-.389l-.445-.257v1.825Zm-.04-3.089c.124.072.217.055.277-.053a1.4,1.4,0,0,0,.092-.62,2.165,2.165,0,0,0-.085-.691.631.631,0,0,0-.273-.351l-.416-.24v1.721Zm-1.221,3.524a.958.958,0,0,1-.052-.348v-6.476a.51.51,0,0,1,.052-.279l.164,0,1.051.608a2.615,2.615,0,0,1,1.232,2.472c0,.779-.176,1.252-.528,1.416l.005.045a2.278,2.278,0,0,1,.469.876,4.038,4.038,0,0,1,.171,1.213,1.926,1.926,0,0,1-.337,1.3q-.336.368-.995-.012l-1.068-.616-.164-.193",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M596.642-383.513a4.331,4.331,0,0,1-.375-1.853v-4.848c0-.224.113-.269.34-.139l.235.136a.591.591,0,0,1,.339.529v4.744a2.1,2.1,0,0,0,.136.773.9.9,0,0,0,.364.475.243.243,0,0,0,.36-.063,1.055,1.055,0,0,0,.139-.608v-4.745c0-.223.112-.269.339-.139l.231.133a.6.6,0,0,1,.339.531v4.848a2.025,2.025,0,0,1-.372,1.423q-.372.368-1.035-.013a2.578,2.578,0,0,1-1.039-1.184",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M600.026-381.128a2.1,2.1,0,0,1-.411-.648,1.329,1.329,0,0,1-.076-.408,1.634,1.634,0,0,1,.088-.544c.059-.168.123-.232.195-.191l.148.191.151.232a1.41,1.41,0,0,0,.405.443.3.3,0,0,0,.315.025c.091-.051.136-.2.136-.453a1.8,1.8,0,0,0-.071-.52,2.056,2.056,0,0,0-.173-.423q-.1-.186-.3-.484a5.954,5.954,0,0,1-.645-1.321,4.791,4.791,0,0,1-.2-1.461,1.809,1.809,0,0,1,.337-1.275c.224-.225.523-.229.895-.016a1.972,1.972,0,0,1,.421.353,2.276,2.276,0,0,1,.347.467.893.893,0,0,1,.105.425,2.2,2.2,0,0,1-.067.535c-.045.176-.1.244-.168.205l-.171-.181a1.583,1.583,0,0,0-.381-.377c-.155-.089-.264-.092-.323-.008a.63.63,0,0,0-.087.356,1.673,1.673,0,0,0,.113.655,4.7,4.7,0,0,0,.361.652l.135.212a5.354,5.354,0,0,1,.584,1.235,4.693,4.693,0,0,1,.179,1.364,3.086,3.086,0,0,1-.141,1,.878.878,0,0,1-.428.552.758.758,0,0,1-.709-.108,2.353,2.353,0,0,1-.569-.481",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M603.393-379.184a2.123,2.123,0,0,1-.411-.648,1.324,1.324,0,0,1-.075-.408,1.639,1.639,0,0,1,.087-.544c.059-.168.123-.232.195-.191l.149.191.149.232a1.427,1.427,0,0,0,.405.443.3.3,0,0,0,.316.025c.089-.051.135-.2.135-.453a1.8,1.8,0,0,0-.071-.52,2.057,2.057,0,0,0-.172-.423c-.069-.124-.168-.285-.3-.484a5.944,5.944,0,0,1-.644-1.321,4.751,4.751,0,0,1-.2-1.461,1.815,1.815,0,0,1,.337-1.275c.225-.225.524-.229.895-.016a1.975,1.975,0,0,1,.423.353,2.3,2.3,0,0,1,.345.467.874.874,0,0,1,.105.425,2.2,2.2,0,0,1-.067.535c-.045.176-.1.244-.168.205l-.169-.181a1.632,1.632,0,0,0-.381-.377c-.156-.089-.264-.092-.323-.008a.619.619,0,0,0-.088.356,1.7,1.7,0,0,0,.113.655,4.7,4.7,0,0,0,.361.652l.135.212a5.3,5.3,0,0,1,.584,1.235,4.691,4.691,0,0,1,.179,1.364,3.126,3.126,0,0,1-.14,1,.887.887,0,0,1-.428.552.76.76,0,0,1-.711-.108,2.376,2.376,0,0,1-.569-.481",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M606.186-377.816v-5.62l-.652-.376-.129-.2a1.7,1.7,0,0,1-.04-.42v-.323a1.169,1.169,0,0,1,.04-.373l.129-.051,2.228,1.287.136.2a1.683,1.683,0,0,1,.041.42v.323a1.155,1.155,0,0,1-.041.373l-.136.047-.656-.38v5.62q0,.334-.341.139l-.24-.139a.593.593,0,0,1-.339-.531",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M609.969-376.809a1.2,1.2,0,0,0,.193-.613,11.381,11.381,0,0,0,.064-1.4,13.276,13.276,0,0,0-.064-1.46,2.942,2.942,0,0,0-.193-.836.849.849,0,0,0-.34-.405.26.26,0,0,0-.344.011,1.162,1.162,0,0,0-.2.609,10.62,10.62,0,0,0-.067,1.385,12.731,12.731,0,0,0,.067,1.467,2.924,2.924,0,0,0,.2.845.873.873,0,0,0,.344.407C609.769-376.717,609.883-376.72,609.969-376.809Zm-1.884-3.247q0-3.732,1.537-2.845a2.733,2.733,0,0,1,1.141,1.567,9.63,9.63,0,0,1,.391,3.051,5.85,5.85,0,0,1-.391,2.6q-.39.682-1.141.249-1.536-.888-1.537-4.621",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M612.907-377.7l.235-.073a1.459,1.459,0,0,0,.1-.673,2.292,2.292,0,0,0-.1-.771.657.657,0,0,0-.235-.34l-.311-.179v1.856Zm-1.208,3.067V-381.2a.493.493,0,0,1,.055-.287l.179,0,1.016.587a2.244,2.244,0,0,1,.817.947,4.472,4.472,0,0,1,.355,2.013,3.011,3.011,0,0,1-.2,1.305c-.137.259-.291.4-.459.419a.7.7,0,0,1-.452-.084l-.4-.233v2.42q0,.334-.352.129l-.2-.113a.606.606,0,0,1-.351-.537",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "M273.294-131.7,152.5-193.3v-41.727l120.8,61.6V-131.7",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M449.373-233.359l-120.8-61.6v-41.727l120.8,61.6v41.722",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M211.869-96.238l-120.8-61.6V-199.56l120.8,61.6v41.723",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M387.949-197.894l-120.8-61.6v-41.727l120.8,61.6v41.722",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M255.67-153.964l5.423-12.066-14.5-7.562v0c-4.612-2.389-10.588-1.832-17,2.255-13.612,8.678-24.018,29.977-23.245,47.571.405,9.213,3.8,15.576,8.893,18.308l0,.007.2.106.029.016L230.338-97.6l5.72-12.729c11.465-9.609,19.842-27.924,19.611-43.639",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M255.67-153.964l5.423-12.066-14.5-7.562v0c-4.612-2.389-10.588-1.832-17,2.255-13.612,8.678-24.018,29.977-23.245,47.571.405,9.213,3.8,15.576,8.893,18.308l0,.007.2.106.029.016L230.338-97.6l5.72-12.729c11.465-9.609,19.842-27.924,19.611-43.639",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M270.729-147.351c.668,15.169-6.981,33.1-17.828,43.3l-.043.048a37.419,37.419,0,0,1-5.372,4.218c-13.613,8.686-25.285,1.453-26.049-16.137-.584-13.29,5.212-28.709,13.949-39.188l.076-.083a40.866,40.866,0,0,1,9.217-8.3c13.614-8.674,25.274-1.453,26.049,16.138",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M270.729-147.351c.668,15.169-6.981,33.1-17.828,43.3,6.359-7.561,12.74-20.034,14.673-31.744,1.693-10.237.249-24.758-8.618-28.054-8.8-3.276-20.016,4.964-23.493,8.656a40.867,40.867,0,0,1,9.217-8.3c13.614-8.674,25.274-1.453,26.049,16.138",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M233.108-123.357c-.432-9.805,5.028-21.458,12.194-26.027s13.328-.325,13.758,9.48-5.028,21.457-12.194,26.026-13.326.325-13.758-9.478M230.4-121.63c.523,11.85,7.968,16.981,16.629,11.457s15.262-19.607,14.74-31.458-7.966-16.981-16.629-11.458-15.261,19.608-14.74,31.459",
    transform: "translate(0 533.387)",
    fill: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M233.1-123.354c.164,3.727,1.165,6.661,2.732,8.6,2.536,3.156,6.585,3.705,11.022.88,7.18-4.573,12.637-16.218,12.205-26.02-.3-6.858-3.4-10.993-7.688-11.3a10.057,10.057,0,0,0-6.081,1.809c-7.165,4.572-12.622,16.232-12.19,26.034",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 533.387)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M235.837-112.975h23.221v-38.241H235.837Z",
    fill: "#75797b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M233.1-123.354c.164,3.727,1.165,6.661,2.732,8.6a10,10,0,0,0,6.095-1.809c7.165-4.557,12.624-16.217,12.192-26.019-.164-3.741-1.165-6.676-2.747-8.612a10.057,10.057,0,0,0-6.081,1.809c-7.165,4.572-12.622,16.232-12.19,26.034",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M247.619-137.839l2.709,6.876,5.164-12.777a10.764,10.764,0,0,0-1.4-4.2l-6.472,10.1",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M250.235-132.434l-4.039,6.268,4.475,4.693a8.321,8.321,0,0,0,2.264-3.4l-2.7-7.559",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M241.361-127.092l1.232.457.243-1.405,4.8,1.1-9.11,14.267a7.264,7.264,0,0,1-2.685-2.089c-.16-.2-.309-.414-.457-.631l5.981-11.7",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M233.386-128.51l7.974,1.419.679-1.219.8.271,1.024-6.133-.933.593-.007-1.577-7.982.3a33.956,33.956,0,0,0-1.551,6.345",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M242.919-135.157l1.183-.436-.244,1.42L248.9-137.4l-5.045-10.965a22.957,22.957,0,0,0-3.7,3.781l2.759,9.429",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "M241.175-128.5c.163,3.709,2.493,5.314,5.205,3.585s4.776-6.136,4.613-9.845-2.495-5.316-5.205-3.587-4.777,6.137-4.613,9.846",
    transform: "translate(0 533.387)",
    fill: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M431.525-255.556l5.423-12.068-14.5-7.562v0c-4.612-2.389-10.588-1.832-17,2.256-13.612,8.678-24.018,29.977-23.245,47.569.405,9.213,3.8,15.576,8.893,18.308l0,.007.205.107.029.016,14.866,7.732,5.72-12.728c11.465-9.61,19.842-27.926,19.612-43.639",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "M431.525-255.556l5.423-12.068-14.5-7.562v0c-4.612-2.389-10.588-1.832-17,2.256-13.612,8.678-24.018,29.977-23.245,47.569.405,9.213,3.8,15.576,8.893,18.308l0,.007.205.107.029.016,14.866,7.732,5.72-12.728c11.465-9.61,19.842-27.926,19.612-43.639",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M446.585-248.944c.668,15.169-6.981,33.1-17.828,43.306l-.043.047a37.434,37.434,0,0,1-5.372,4.217c-13.613,8.686-25.285,1.455-26.049-16.137-.585-13.289,5.212-28.709,13.949-39.188l.076-.083a40.87,40.87,0,0,1,9.217-8.3c13.614-8.674,25.274-1.453,26.049,16.138",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "M446.585-248.944c.668,15.169-6.981,33.1-17.828,43.306,6.358-7.561,12.74-20.036,14.673-31.746,1.693-10.236.248-24.758-8.618-28.054-8.8-3.276-20.015,4.965-23.493,8.656a40.87,40.87,0,0,1,9.217-8.3c13.614-8.674,25.274-1.453,26.049,16.138",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M408.963-224.95c-.432-9.805,5.028-21.458,12.194-26.027s13.326-.325,13.758,9.48-5.028,21.457-12.194,26.026-13.326.327-13.758-9.478m-2.708,1.727c.523,11.85,7.968,16.981,16.629,11.457s15.262-19.608,14.74-31.458-7.966-16.981-16.629-11.458-15.261,19.608-14.74,31.459",
    transform: "translate(0 533.387)",
    fill: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "M408.96-224.948c.164,3.727,1.165,6.661,2.732,8.6,2.536,3.157,6.585,3.705,11.022.88,7.178-4.573,12.637-16.218,12.205-26.021-.3-6.858-3.4-10.993-7.688-11.3a10.045,10.045,0,0,0-6.081,1.808c-7.165,4.572-12.622,16.232-12.19,26.034",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M417.17-213.636a6.864,6.864,0,0,1-5.477-2.715c.189.015.381.023.575.023a10.437,10.437,0,0,0,5.52-1.832c6.321-4.02,11.314-13.569,12.106-22.493v10.39l.925.535,1.388.8v0l0,0,.62-.359a33.224,33.224,0,0,1-5.308,9.43,20.816,20.816,0,0,1-4.807,4.383,10.436,10.436,0,0,1-5.545,1.835m-8.233-12.41h0c0-9.56,5.316-20.533,12.214-24.935a10.431,10.431,0,0,1,5.543-1.828c.181,0,.361.007.539.02a6.63,6.63,0,0,1,2.661.757v2.583l-.573.895a11.553,11.553,0,0,0-2.088-4.235c-.177-.013-.357-.02-.539-.02a10.431,10.431,0,0,0-5.543,1.828c-6.9,4.4-12.214,15.376-12.214,24.935",
    transform: "translate(0 533.387)",
    fill: "#75797b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "M408.96-224.948c.164,3.727,1.165,6.661,2.732,8.6a9.995,9.995,0,0,0,6.095-1.809c7.165-4.557,12.624-16.217,12.192-26.019-.164-3.741-1.165-6.676-2.747-8.61a10.045,10.045,0,0,0-6.081,1.808c-7.165,4.572-12.622,16.232-12.19,26.034",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M423.475-239.433l2.709,6.876,5.163-12.777a10.746,10.746,0,0,0-1.4-4.2l-6.472,10.1",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "M426.092-234.027l-4.04,6.268,4.475,4.693a8.323,8.323,0,0,0,2.264-3.4l-2.7-7.558",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M417.216-228.684l1.232.456.243-1.405,4.8,1.1-9.11,14.268a7.264,7.264,0,0,1-2.685-2.089c-.16-.2-.309-.413-.457-.631l5.981-11.7",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M409.242-230.1l7.974,1.42.679-1.22.8.271,1.024-6.133-.933.593-.007-1.577-7.982.3a33.919,33.919,0,0,0-1.551,6.344",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M418.775-236.75l1.181-.436-.241,1.42L424.759-239l-5.045-10.965a22.959,22.959,0,0,0-3.7,3.781l2.759,9.429",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "M417.031-230.094c.163,3.709,2.493,5.315,5.205,3.585s4.776-6.136,4.612-9.845-2.493-5.315-5.2-3.587-4.777,6.137-4.613,9.846",
    transform: "translate(0 533.387)",
    fill: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M120.325-111.045l0,56.757c0,4.211,2.557,6.144,5.715,4.32l91.84-53.024v-12.253c0-10.208,3.1-21.221,8.122-30.821,5.008-9.569,11.928-17.7,19.582-22.115,15.3-8.832,27.706.529,27.706,20.945v12.254l120.682-69.673v-12.254c0-10.208,3.1-21.221,8.108-30.811,5.008-9.57,11.928-17.7,19.582-22.115,15.313-8.84,27.706.529,27.706,20.945v12.253l60.185-34.768L559.9-308.086c2.977-2.06,5.249-6.681,5.235-10.622-.105-45.263-1.189-104.163-3.46-128.321-1.956-20.81-6.934-24.875-18.336-18.293-9.2,5.315-351.717,204.843-351.717,204.843l-43.966,37.115c-4.287,3.437-8,9.052-10.122,15.33-5.986,17.754-17.21,56.417-17.21,96.988",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "M120.325-111.045l0,56.757c0,4.211,2.557,6.144,5.715,4.32l91.84-53.024v-12.253c0-10.208,3.1-21.221,8.122-30.821,5.008-9.569,11.928-17.7,19.582-22.115,15.3-8.832,27.706.529,27.706,20.945v12.254l120.682-69.673v-12.254c0-10.208,3.1-21.221,8.108-30.811,5.008-9.57,11.928-17.7,19.582-22.115,15.313-8.84,27.706.529,27.706,20.945v12.253l60.185-34.768L559.9-308.086c2.977-2.06,5.249-6.681,5.235-10.622-.105-45.263-1.189-104.163-3.46-128.321-1.956-20.81-6.934-24.875-18.336-18.293-9.2,5.315-351.717,204.843-351.717,204.843l-43.966,37.115c-4.287,3.437-8,9.052-10.122,15.33-5.986,17.754-17.21,56.417-17.21,96.988",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M123.773-49.282c-.055,0-.109,0-.163,0a3.057,3.057,0,0,1-1.453-.471c-.023-.015-.047-.031-.07-.047l28.106-16.224V-68.7L170.24-80.263a5.442,5.442,0,0,1,.992.472c.991.605,1.663,1.389,2.671,1.944.084.036.169.069.256.1l-8.865,5.119L126.044-49.968a4.578,4.578,0,0,1-2.271.687M179.7-80.943c.013-1.814,0-3.832-.544-4.416a3.046,3.046,0,0,0,.641.264,2.838,2.838,0,0,0,.656.091,2.3,2.3,0,0,0,1.081-.321l2.276-1.133c.908-.461,1.66-1,1.723-2.014l.04-.633,9.334-5.384h0v-.226h0v.224l.092.054c.033.1.067.2.1.3.363,1.095.773,2.33,1.2,3.605l-16.6,9.587m26.569-15.341c-.065-.675-.147-1.33-.237-1.956l5.84-3.372v2.095l-3.016,1.741-2.587,1.492m67.029-38.7v-12.254h0v12.254m6.016-3.475V-150.71c0-18.478-8.394-29.529-20.361-29.529a26.976,26.976,0,0,0-13.361,4.036c-7.568,4.369-14.562,11.748-20.2,20.635v-17.216l204.5-118.242v9.769a31.33,31.33,0,0,0-8.226,3.4c-18.59,10.733-33.706,39.616-33.706,64.424v12.253l-.012.007-3.019,1.743-20.987,12.117c-.016-1.215-.071-2.447-.2-3.635a29.571,29.571,0,0,0-2.192-8.128l-6.828-1.061-2.351-.4-6.152,1.329-1.748.579h0l-1.343.444-.02.023,0-.019a22.174,22.174,0,0,0-5.252,2.572c-5.5,3.3-10.469,6.358-10.469,6.358l-2.777-1.419v-8.213a.494.494,0,0,0-.248-.428.5.5,0,0,0-.247-.067.5.5,0,0,0-.248.067l-7.353,4.244a9.282,9.282,0,0,1-2.364-3.583c-.931-2.117-1.267-2.231-2.272-2.889-.624-.411-2.028-1.565-2.08-1.6a2.025,2.025,0,0,0-.728-.272c-.135-.039-.7-.171-.832-.2-.781-.185-1.272-.257-2.053-.443a3.486,3.486,0,0,0-.729-.12l-.153.031-.067.281a1.756,1.756,0,0,0,.881,1.108,6.1,6.1,0,0,0,1.364.509c.288.084.451.109,1.031.284a1.359,1.359,0,0,1,.595.411,16.266,16.266,0,0,1,2.247,2.676,5.783,5.783,0,0,1-2.672-1.5.7.7,0,0,0-.476-.243c-.444,0-.691.712-.208,1.548.735,1.275,1.849,1.455,2.784,3.167.715,1.309.071,2.587.713,3.737l-27.9,16.106a.5.5,0,0,0-.248.431v27.9a.5.5,0,0,0,.248.429l.248.065.248-.065,40.271-23.253a.5.5,0,0,0,.248-.429v-10.71a5.8,5.8,0,0,0,2.437,1.143,1.537,1.537,0,0,0,.236.017c.749,0,1.7-.513,3.437-1.268,1.192-.517,4.92-2.377,7.589-3.719a8.485,8.485,0,0,0,1.955,3.293s.479,4.583.591,8.233L279.31-138.457m5.035-10.13v-26.757l27.821-16.064a4.1,4.1,0,0,0,.368.261,31.3,31.3,0,0,1,3.6,2.277c.275.209.641.508,1.069.864v16.474l1.2-.725.024-14.714.241.208c-.119.019-.188.024-.188.024s1.984,1.74,4.379,3.7q.41.336.768.613v11.153l-39.28,22.681m6.424-26.494-1.228.708v18.8l1.2-.725.031-18.78m3.457-1.995-1.228.708v18.8l1.2-.725.031-18.78m3.459-1.995-1.229.709v18.8l1.2-.725.031-18.78m3.457-1.993-1.228.708v18.8l1.2-.727.031-18.778m3.459-1.995-1.228.708v18.8l1.2-.725.031-18.78m3.459-1.993-1.229.708v18.8l1.2-.725.031-18.778m3.457-1.995-1.228.708v18.8l1.2-.725.031-18.78m3.457-1.995-1.228.708v18.8l1.2-.725.031-18.78m-69.3,20.813a22.154,22.154,0,0,1,10.918-3.279,22.168,22.168,0,0,0-10.918,3.279m10.926-3.279h0m-31.2-12.732v-.005l6.531-3.771-6.531,3.776m98.232-6.938-1.663-.851a1.834,1.834,0,0,1,.036.18c-1.764-.932-3.448-1.836-4.135-2.245-.175-.1-.34-.211-.5-.317l6.258-3.613v6.846m-186.334-2.959c.019-.115.039-.229.059-.343,1-5.768,2.461-11.454-.141-12.558l54.684-44.888L558.227-463.282c1.647,3.436,2.744,8.76,3.448,16.253,2.271,24.158,3.355,83.058,3.46,128.321v.047c0,3.931-2.268,8.524-5.234,10.576l-24.31,17.712h0l1.28-.933V-314.4l-1.28.739v-4.661l19.274-11.128a2,2,0,0,1,.989-.3c.885,0,1.507.817,1.507,2.185v21.325l1.5-1.1v-21.1c0-2.189-1-3.5-2.416-3.5a3.2,3.2,0,0,0-1.584.477l-19.274,11.129v-31.815l29.062-16.8c-.047-2.569-.161-8.786-.215-11.318l-28.847,16.678v-.043l18.965-10.948c1.817-1.051,3.287-4,3.287-6.611v-.005h0v-25.845l-16.366,9.448,0,0-5.881,3.4v-4.067L557.842-411.1v-17.206c0-1.972-.853-3.184-2.064-3.184a2.462,2.462,0,0,0-1.223.368l-19.641,11.34a1.439,1.439,0,0,0-.451-.3c-.556-.323-1.813-1.056-2.188-1.265a1.4,1.4,0,0,0-.689-.175,2.193,2.193,0,0,0-1.095.333L505.1-406.531h0l-1.7.981-.78.451h0l-22.846,13.19-21.7,12.494h-.005l-25.389,14.66a6.69,6.69,0,0,0-2.793,5.333v.876a1.728,1.728,0,0,0-.187-.009,2.449,2.449,0,0,0-1.223.368l-44.742,25.831c-1.819,1.049-3.287,4.023-3.287,6.611v17.206l49.437-28.543v4.072L415.4-324.645l-.005,0-23.474,13.553v.005l-11.469,6.621v25.85c0,1.984.849,3.187,2.056,3.187a2.489,2.489,0,0,0,1.231-.371l16.53-9.544L260.842-204.734a8.5,8.5,0,0,0,2.956-6.395v-.005h0v-25.846l-16.366,9.449,0,0-22.034,12.722v-4.067l38.4-22.173v-17.206c0-1.972-.853-3.183-2.064-3.183a2.464,2.464,0,0,0-1.223.367l-35.666,20.591a1.484,1.484,0,0,0-.579-.437c-.556-.321-1.815-1.056-2.188-1.265a1.406,1.406,0,0,0-.691-.175,2.182,2.182,0,0,0-1.093.335l-25.389,14.658h0l-2.481,1.432h0l-22.846,13.19-21.7,12.494h-.005l-10.586,6.113M541.308-316.959l-1.5.868v22.647l1.5-1.1v-22.419m4.436-2.561-1.5.869v21.975l1.5-1.1V-319.52m4.437-2.561-1.5.868v21.3l1.5-1.1v-21.077m4.437-2.563-1.5.869v20.633l1.5-1.1v-20.406m-99.228,84.53V-242.3l5-2.888v-2.673l36.562-21.091c.293,1.312.627,2.772.973,4.269L455.39-240.114m-33.528-29.833a24.353,24.353,0,0,1,8.032-2.987h0a24.319,24.319,0,0,0-8.032,2.985m100.953-11.12h0l.747-.544v-.032l.215-.124-.961.7m-94-20.78a5.521,5.521,0,0,0,1.083-1.055v.429l-1.083.625M558.089-463.563a8.771,8.771,0,0,0-3.307-3.832l.009-.005a8.784,8.784,0,0,1,3.3,3.837",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "M564.438-380.26c.053,2.532.168,8.749.215,11.318L205.736-161.417v-11.456l358.7-207.387",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M449.373-233.359v-15.532c0-20.415-12.393-29.785-27.706-20.945-7.654,4.42-14.574,12.545-19.582,22.115-5.009,9.59-8.108,20.6-8.108,30.811v15.533l-6.016,3.473v-15.532c0-24.807,15.116-53.691,33.706-64.424,18.606-10.741,33.723.685,33.723,25.494v15.532l-6.017,3.473",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "M273.294-131.7v-15.533c0-20.415-12.409-29.777-27.706-20.945-7.654,4.42-14.574,12.546-19.582,22.115-5.024,9.6-8.122,20.613-8.122,30.821v15.533l-6.016,3.473v-15.532c0-24.809,15.13-53.7,33.721-64.432s33.722.685,33.722,25.493v15.532l-6.016,3.474",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M522.815-281.066c-.005-.047-.009-.091-.013-.137l.76-.439v.032l-.747.544m12.776-9.308v-23.283l1.28-.739v23.089l-1.28.933m4.213-3.069v-22.647l1.5-.868v22.419l-1.5,1.1m4.436-3.232v-21.975l1.5-.869v21.749l-1.5,1.1m4.437-3.233v-21.3l1.5-.868V-301l-1.5,1.1m4.437-3.233v-20.633l1.5-.869v20.406l-1.5,1.1m4.247-3.093V-327.56c0-1.368-.621-2.185-1.507-2.185a2,2,0,0,0-.989.3l-19.274,11.128v-2.005l19.274-11.129a3.205,3.205,0,0,1,1.584-.477c1.42,0,2.416,1.312,2.416,3.5v21.1l-1.5,1.1",
    transform: "translate(0 533.387)",
    fill: "#6064c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "M123.541-62.334l-3.212,1.855V-76.969l3.212-1.855c1.139-.656,2.061.042,2.061,1.559v10.993a4.935,4.935,0,0,1-2.061,3.937",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M431.771-334.094l-51.315,29.626v25.85c0,2.608,1.468,3.865,3.287,2.816l44.742-25.831c1.817-1.049,3.287-4,3.287-6.611v-25.85m-51.315,8.349v17.206l51.315-29.626v-17.208c0-2.587-1.469-3.865-3.287-2.815l-44.742,25.831c-1.819,1.049-3.287,4.023-3.287,6.611",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "M375.836-301.8l-51.315,29.627v25.85c0,2.608,1.469,3.865,3.287,2.816l44.742-25.831c1.819-1.051,3.287-4,3.287-6.611Zm-51.315,8.349v17.208l51.315-29.627v-17.206c0-2.588-1.468-3.865-3.287-2.816l-44.742,25.831c-1.817,1.051-3.287,4.024-3.287,6.611",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M380.456-295.941v17.317c0,2.608,1.468,3.865,3.287,2.816l44.742-25.831c1.817-1.049,3.285-4,3.285-6.611V-315.2l-16.37-9.45-23.474,13.553c-.453,3.484-.919,7.541-1.421,12.312l-7.486,4.323-2.561-1.48m12.084-19.581,19.334-11.162-11.745-6.781c-3.764,2.173-5.657,5.063-7.589,17.944",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "M557.842-407.033l-51.315,29.626v25.85c0,2.607,1.468,3.865,3.287,2.816l44.742-25.831c1.817-1.051,3.287-4,3.287-6.611v-25.85m-51.315,8.348v17.208L557.842-411.1v-17.206c0-2.588-1.469-3.865-3.287-2.816L509.814-405.3c-1.819,1.051-3.287,4.024-3.287,6.611",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M506.527-368.879v17.317c0,2.607,1.468,3.865,3.287,2.815l44.742-25.831c1.817-1.049,3.287-4,3.287-6.609v-6.948l-16.37-9.452L518-384.034c-.453,3.485-.919,7.543-1.421,12.312l-7.486,4.323-2.561-1.479m12.084-19.581,19.334-11.162L526.2-406.4c-3.764,2.173-5.657,5.063-7.589,17.944",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "M324.521-263.643v17.317c0,2.608,1.469,3.865,3.287,2.816l44.742-25.831c1.819-1.051,3.287-4,3.287-6.61V-282.9l-16.37-9.452L335.992-278.8c-.453,3.485-.919,7.542-1.421,12.313l-7.486,4.323Zm12.085-19.581,19.334-11.162L344.2-301.167c-3.765,2.173-5.657,5.063-7.589,17.944",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M319.731-269.272l-51.315,29.626v25.85c0,2.608,1.469,3.865,3.287,2.816l44.742-25.831c1.819-1.049,3.287-4,3.287-6.611Zm-51.315,8.349v17.206l51.315-29.627V-290.55c0-2.587-1.468-3.865-3.287-2.815L271.7-267.533c-1.817,1.049-3.287,4.023-3.287,6.611",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "M263.8-236.979l-51.315,29.627v25.85c0,2.608,1.468,3.865,3.287,2.816l44.742-25.833c1.817-1.049,3.287-4,3.287-6.609v-25.851m-51.315,8.349v17.208L263.8-241.05v-17.206c0-2.588-1.469-3.865-3.287-2.816l-44.742,25.831c-1.819,1.051-3.287,4.024-3.287,6.61",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M268.417-231.113V-213.8c0,2.608,1.468,3.865,3.285,2.816l44.742-25.831c1.819-1.049,3.287-4,3.287-6.611v-6.948l-16.37-9.45-23.474,13.553c-.453,3.485-.919,7.541-1.421,12.312l-7.486,4.323ZM280.5-250.694l19.334-11.162-11.745-6.781c-3.765,2.173-5.657,5.063-7.589,17.944",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "M212.483-198.824v17.317c0,2.607,1.468,3.865,3.287,2.815l44.742-25.831c1.817-1.049,3.287-4,3.287-6.609v-6.948l-16.37-9.452L223.953-213.98c-.453,3.485-.92,7.541-1.423,12.312l-7.485,4.323-2.563-1.479m12.084-19.581L243.9-229.568l-11.744-6.781c-3.765,2.173-5.657,5.063-7.59,17.944",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M283.85-147.234l-.248-.065a.5.5,0,0,1-.248-.429v-27.9a.5.5,0,0,1,.248-.431l27.9-16.106a2.581,2.581,0,0,0,.664.76l-27.821,16.064v26.757l39.28-22.681v-11.153c.368.284.7.525.992.729v10.71a.5.5,0,0,1-.248.429L284.1-147.3l-.248.065m5.689-8.342v-18.8l1.228-.708-.031,18.78-1.2.725M293-157.571v-18.8l1.228-.708L294.2-158.3l-1.2.725m3.459-1.995v-18.8l1.229-.709-.031,18.78-1.2.725m3.459-1.993v-18.8l1.228-.708-.031,18.778-1.2.727m3.457-1.995v-18.8l1.228-.708-.031,18.78-1.2.725m3.459-1.995v-18.8l1.229-.708-.031,18.778-1.2.725m3.457-1.993v-18.8l1.228-.708-.031,18.78-1.2.725m3.459-1.995v-18.8l1.228-.708-.031,18.78-1.2.725m3.457-1.995V-188c.369.308.783.66,1.221,1.035l-.024,14.714-1.2.725m7.414-19.14-.992-.507v-6.846l-6.259,3.613a8.3,8.3,0,0,1-.845-.657l7.353-4.244a.5.5,0,0,1,.248-.067.5.5,0,0,1,.247.067.5.5,0,0,1,.248.428v8.213",
    transform: "translate(0 533.387)",
    fill: "#6d70cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "M24.659-273.2c2.121-6.279,5.836-11.892,10.123-15.33l43.964-37.115S421.258-525.178,430.463-530.492c4.919-2.839,8.641-3.677,11.445-2.06l.019-.012L554.792-467.4l-.02.012a8.982,8.982,0,0,1,3.456,4.107L191.893-251.924,137.2-207.035,24.329-272.2c.108-.324.225-.689.33-1",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M67.816-261.771a2.823,2.823,0,0,0,2.432,1.228,7.584,7.584,0,0,0,6.4-3.391,2.6,2.6,0,0,0,.221-2.633,5.508,5.508,0,0,0-7.236-2.332,5.089,5.089,0,0,0-1.821,7.128",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "M85.02-251.163a2.823,2.823,0,0,0,2.432,1.228,7.584,7.584,0,0,0,6.4-3.391,2.6,2.6,0,0,0,.221-2.633,5.51,5.51,0,0,0-7.236-2.333,5.091,5.091,0,0,0-1.821,7.129",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M102.225-240.555a2.826,2.826,0,0,0,2.432,1.228,7.585,7.585,0,0,0,6.4-3.391,2.6,2.6,0,0,0,.221-2.633,5.509,5.509,0,0,0-7.236-2.333,5.09,5.09,0,0,0-1.821,7.129",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "M132.6-229.094a.865.865,0,0,0,.559-.205l43.964-37.115c.027,0,342.389-199.44,351.593-204.754a.867.867,0,0,0,.316-1.187.869.869,0,0,0-1.185-.317c-9.2,5.315-351.718,204.843-351.718,204.843l-44.089,37.2a.867.867,0,0,0-.1,1.223.865.865,0,0,0,.664.309",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M115.065-238.967a.864.864,0,0,0,.559-.205l43.965-37.115L511.181-481.041a.867.867,0,0,0,.317-1.187.868.868,0,0,0-1.185-.317L158.6-277.7l-44.091,37.2a.867.867,0,0,0-.1,1.223.865.865,0,0,0,.664.309",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "M97.534-248.84a.866.866,0,0,0,.56-.205l43.964-37.115c.027,0,342.387-199.439,351.593-204.754a.868.868,0,0,0,.317-1.185.871.871,0,0,0-1.187-.319c-9.205,5.314-351.718,204.843-351.718,204.843l-44.089,37.2a.866.866,0,0,0-.1,1.223.868.868,0,0,0,.663.308",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M80-258.714a.864.864,0,0,0,.559-.2l43.964-37.116c.027,0,342.39-199.439,351.591-204.752a.867.867,0,0,0,.317-1.187.871.871,0,0,0-1.185-.319c-9.2,5.315-351.717,204.844-351.717,204.844l-44.089,37.2a.866.866,0,0,0-.1,1.223.864.864,0,0,0,.663.308",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "M62.47-268.585a.864.864,0,0,0,.559-.205l43.964-37.115c.027,0,342.389-199.44,351.593-204.754a.869.869,0,0,0,.317-1.187.871.871,0,0,0-1.185-.317C448.513-506.849,106-307.32,106-307.32l-44.09,37.2a.866.866,0,0,0-.1,1.223.863.863,0,0,0,.663.309",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M44.937-278.458a.866.866,0,0,0,.56-.205l43.965-37.114L441.053-520.532a.867.867,0,0,0,.317-1.187.869.869,0,0,0-1.185-.317L88.469-317.193l-44.091,37.2a.866.866,0,0,0-.1,1.223.865.865,0,0,0,.663.309",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "M137.535-208.033c2.121-6.279,5.836-11.893,10.122-15.33l43.966-37.115S534.136-460.007,543.34-465.322c7.288-4.207,11.961-4.045,14.888,2.04L191.893-251.924l-54.687,44.89c.108-.323.225-.688.329-1",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M7.448-176.212v56.757a5.577,5.577,0,0,0,.62,3.084c5.013,7.252,20.357,22.27,43.41,36.4,24.394,14.953,60.858,31.6,72.164,30.688a3.144,3.144,0,0,1-1.6-.545c-1.059-.781-1.719-2.326-1.719-4.464l0-56.754c0-39.824,10.833-77.828,16.877-95.994L24.33-272.2c-6.079,18.184-16.881,56.167-16.881,95.991",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "M122.7-49.246c-12.275,0-47.47-16.166-71.221-30.724-23.053-14.13-38.4-29.149-43.41-36.4a5.577,5.577,0,0,1-.62-3.084V-154.28q0,.314,0,.628h0c1.025,8.169,7.976,20.7,49.388,44.053C87.1-92.53,103.555-86.045,112.767-86.045a11.349,11.349,0,0,0,6.927-1.926v11.238c-8.317,2.947-17.262.3-18,3.843s9.225,12,18,12.4v9.4l.892.515,1.421.825v-.005l0,0,.072-.042a3.12,3.12,0,0,0,1.559.519c-.3.024-.611.036-.944.036M7.448-166.757v-9.454h0v9.4h0s0,0,0,0v.059m0-9.564v0m0-.108v0m0-.111v0m0-.112v0m0-.108v0m0-.145v0m0-.109v0m0-.111c0-.017,0-.033,0-.051,0,.016,0,.033,0,.051m0-.107c0-.016,0-.037,0-.055,0,.019,0,.037,0,.055m0-.105c0-.021,0-.039,0-.06,0,.02,0,.04,0,.06m0-.1c0-.083,0-.168,0-.249l0,.249m0-.271c0-.027,0-.056,0-.083,0,.027,0,.055,0,.083m0-.1c0-.027,0-.053,0-.08,0,.027,0,.053,0,.08m0-.105c0-.027,0-.052,0-.079,0,.027,0,.052,0,.079m0-.1c0-.027,0-.057,0-.084,0,.028,0,.057,0,.084",
    transform: "translate(0 533.387)",
    fill: "#6265a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M7.456-178.1c.328-38.608,10.61-75.211,16.63-93.372-1.812,5.465-4.009,12.608-6.206,20.965h0c-5.1,19.413-10.2,45.419-10.427,72.406M137.2-207.027a.034.034,0,0,0,0-.009L24.764-271.952h0L137.2-207.039h0l0,.012M24.09-271.481c0-.009.005-.016.008-.025l-.008.025",
    transform: "translate(0 533.387)",
    fill: "#dbafdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "M120.329-76.969c-8.49,3.321-17.877.444-18.634,4.079s9.713,12.411,18.634,12.411V-76.969",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M7.448-140.842c5.931,12.712,8.616,14.547,9.373,19.054s-3.787,5.81-9.373-2.566v-16.489",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "M28.615-104.148c10.508,8.061,41.9,27.179,53.787,33.042,5.7,2.809,6.873,4,7.046,11.091A353.1,353.1,0,0,1,51.477-79.97a207.191,207.191,0,0,1-31.037-23.075c-.1-2.692,1.121-6.515,8.175-1.1",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M134.258-197.728c1.6-5.187,2.944-9.31,2.944-9.31,2.744,1.153.991,7.38,0,13.442-2.761,16.888-4.668,26.825-6.077,41.91-1.629,17.437-1.622,23.209-2.051,39.848-.1,4.017-1.688,8.456-8.744,10.2l0-9.406c0-33.963,7.86-66.54,13.933-86.683",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "M7.448-176.212v9.4c34.342,34.515,72.057,55.889,112.873,65.181l0-9.41c.208-34.075,7.946-66.378,13.933-86.683L21.377-262.893C15.3-242.747,7.448-210.148,7.448-176.212",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M7.448-176.212c0-2.972.08-5.925.194-8.869,13.94-10.1,28.937-.747,35.9,8.073,7.016,8.881,7.709,20.366,7.709,20.366s20.734,17.988,69.336,36.128c-.143,3.137-.247,6.291-.266,9.468l0,9.41C79.505-110.926,41.791-132.3,7.448-166.816v-9.4",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "M119.695-120.849q-5.315-2-10.186-3.985C92.888-152.8,72.038-191.53,61.67-225.226l26.7,15.418c9.136,21.522,20.69,43.322,31.32,61.814v27.145m-31.426-13.44c-4.526-2.205-8.6-4.325-12.257-6.327-15.163-29.269-32.6-67.253-40.034-99.446l10.47,6.045c8.709,33.229,26.884,71.476,41.822,99.727",
    transform: "translate(0 533.387)",
    fill: "#4d626c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M101.561-109.085c-3.39-1.249-7.053-2.747-10.888-4.438-4.244-7.52-9.312-16.765-14.662-27.091,3.653,2,7.731,4.121,12.257,6.327,4.945,9.352,9.537,17.611,13.311,24.227-.012.316-.018.643-.018.976M119.695-120.1a33.146,33.146,0,0,0-7.284-.968c-.215,0-.429,0-.642.011q-1.115-1.854-2.26-3.78,4.869,1.982,10.186,3.985v.752",
    transform: "translate(0 533.387)",
    fill: "#405059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "M7.643-185.089c.938-24.463,5.592-47.691,10.244-65.416l4.629,2.672c-1.82,10.924-3.19,19.454-4.265,30.981-1.164,12.488-1.494,18.984-1.755,27.789a22.735,22.735,0,0,0-8.853,3.975",
    transform: "translate(0 533.387)",
    fill: "#5d717a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M24.764-271.952l-.434-.251.007,0,.421.244.006,0m-.434-.251h0",
    transform: "translate(0 533.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "M24.758-271.956l-.421-.244a1.9,1.9,0,0,1,.421.244",
    transform: "translate(0 533.387)",
    fill: "#fbfbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M24.764-271.952l-.434-.251h0l.434.251h0",
    transform: "translate(0 533.387)",
    fill: "#e4bee3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    d: "M24.33-272.2,137.2-207.036c-1.845,5.551-4.14,12.961-6.436,21.7L17.881-250.508c2.3-8.734,4.593-16.141,6.449-21.694",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M134.215-197.8c1.6-5.187,2.987-9.234,2.987-9.234,2.745,1.153.991,7.38,0,13.441-.264,1.621-.519,3.161-.769,4.664l-5.666,3.6c1.185-4.508,2.326-8.741,3.45-12.469",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "M129.5-114.689c0,11.74-2.657,20.425-9.172,26.206S98.248-86.241,56.837-109.6,8.473-145.483,7.448-153.652h0c-.06-9.3.02-20.009.17-31.415,12.711,6.053,16.064,18.321,15.182,30.511,17.008,15.309,54.692,36.6,78.757,45.471,0-13.541,10.263-12.952,18.989-10.809l8.846-3.556.1,8.761",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M120.55-119.894l8.846-3.556.1,8.761c0,11.74-2.656,20.425-9.172,26.206l0-22.562c0-2.964.112-5.912.225-8.849",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "M117.305-106.912c-.411,3.75-3.36,5.722-6.588,4.408s-5.51-5.421-5.1-9.17,3.36-5.723,6.587-4.408,5.511,5.421,5.1,9.171",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M106.19-97.642c-.256,2.339-2.095,3.57-4.107,2.748a5.752,5.752,0,0,1-3.18-5.718c.256-2.337,2.1-3.568,4.107-2.748a5.752,5.752,0,0,1,3.179,5.717",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "M19.376-163.081c-.007,3.577-2.192,5.225-4.882,3.681s-4.865-5.7-4.858-9.273,2.192-5.227,4.882-3.683,4.865,5.7,4.858,9.274",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M22.687-145.412c0,2.26-1.385,3.3-3.084,2.325a7.311,7.311,0,0,1-3.07-5.859c0-2.261,1.385-3.3,3.084-2.327a7.313,7.313,0,0,1,3.07,5.86",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "M368.957-453.206a2.066,2.066,0,0,0-1.219,1.7c0,.616,0,3.612,0,4.231a2.073,2.073,0,0,0,1.219,1.689l29.565,17.07a6.51,6.51,0,0,0,5.885,0l76.967-44.375a2.064,2.064,0,0,0,1.219-1.7v-4.221a2.063,2.063,0,0,0-1.219-1.7L451.81-497.58a6.5,6.5,0,0,0-5.885,0l-76.967,44.374",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M482.5-474.088h0m0,0a1.433,1.433,0,0,0,.091-.5v-4.119a.09.09,0,0,0,0-.019c0,1.112,0,3.537,0,4.135a1.514,1.514,0,0,1-.1.5",
    transform: "translate(0 533.387)",
    fill: "#dadbd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "M401.542-427.82c0-3.805-.007-1.06,0-4.216a5.934,5.934,0,0,0,2.865-.7l76.963-44.371a2.13,2.13,0,0,0,1.22-1.6v4.119a1.433,1.433,0,0,1-.091.5h0a2.44,2.44,0,0,1-1.131,1.2l-76.965,44.372a5.978,5.978,0,0,1-2.865.7",
    transform: "translate(0 533.387)",
    fill: "#bfc0be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M398.522-432.739l-29.565-17.069a2.066,2.066,0,0,1-1.219-1.7,2.066,2.066,0,0,1,1.219-1.7l76.967-44.374a6.5,6.5,0,0,1,5.885,0l29.565,17.069a2.068,2.068,0,0,1,1.22,1.7,2.068,2.068,0,0,1-1.22,1.7l-76.967,44.374a6.51,6.51,0,0,1-5.885,0",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "M137.5-319.824a2.067,2.067,0,0,0-1.219,1.7c0,.615,0,3.612,0,4.229a2.076,2.076,0,0,0,1.219,1.691l29.566,17.069a6.5,6.5,0,0,0,5.885,0L249.92-339.51a2.069,2.069,0,0,0,1.219-1.7v-4.221a2.069,2.069,0,0,0-1.219-1.7L220.355-364.2a6.5,6.5,0,0,0-5.884,0L137.5-319.824",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M251.05-340.713a1.428,1.428,0,0,0,.089-.5v-4.116c0-.007,0-.015,0-.021,0,1.111,0,3.536,0,4.135a1.515,1.515,0,0,1-.095.5",
    transform: "translate(0 533.387)",
    fill: "#dadbd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "M170.088-294.438c0-3.805-.007-1.06,0-4.217a5.933,5.933,0,0,0,2.865-.7l76.965-44.372a2.134,2.134,0,0,0,1.22-1.6v4.116a1.428,1.428,0,0,1-.089.5,2.44,2.44,0,0,1-1.133,1.2l-76.963,44.371a5.983,5.983,0,0,1-2.865.7",
    transform: "translate(0 533.387)",
    fill: "#bfc0be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M167.068-299.358,137.5-316.427a2.069,2.069,0,0,1-1.219-1.7,2.067,2.067,0,0,1,1.219-1.7L214.471-364.2a6.507,6.507,0,0,1,5.884,0l29.566,17.07a2.069,2.069,0,0,1,1.219,1.7,2.069,2.069,0,0,1-1.219,1.7l-76.967,44.374a6.5,6.5,0,0,1-5.885,0",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "M479.777-391.909l-21.7,12.494v114.793l0,18.093,47.027-27.13V-406.531l-25.326,14.622",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M473.443-388.254v76.3a.793.793,0,0,1-.467.651,2.491,2.491,0,0,1-2.256,0,.79.79,0,0,1-.467-.651v-74.459l3.189-1.841",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "M505.1-273.659l-16.3-9.416-30.717,17.7v18.845l47.021-27.13",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M458.081-282.957v-18.834l14.4-8.288,16.312,9.417-30.713,17.7",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "M488.793-300.66v17.586l-30.713,17.7v-17.586l30.713-17.7",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M479.023-369.1,505.1-354.034v79.141l-15.348-8.86V-301.34l-16.313-9.418v-55.116a3.72,3.72,0,0,1,5.58-3.221",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "M505.1-324.184h0v0m0-28.614h0v0m-2.48-1.433L478.06-368.416a3.688,3.688,0,0,0-1.855-.5,3.738,3.738,0,0,0-1.648.387,3.767,3.767,0,0,1,2.611-1.067,3.685,3.685,0,0,1,1.855.5l23.6,13.629v1.236",
    transform: "translate(0 533.387)",
    fill: "#efd6ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M505.1-273.657l-16.309-9.417V-300.66l-16.313-9.418v-55.116a3.72,3.72,0,0,1,5.58-3.221L505.1-352.8v79.141",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "M495.3-279.316l-.124-.071-6.385-3.688v-1.977a10.838,10.838,0,0,0,5.4,2.1c.132.007.269.011.411.011.2,0,.407-.008.621-.021-.029,1.2,0,2.405.079,3.643m-9.613-23.137-13.209-7.626v-55.116a3.724,3.724,0,0,1,3.725-3.725,3.688,3.688,0,0,1,1.855.5l24.563,14.185v30.038a33.827,33.827,0,0,0-13.408,4.245c-3.889,2.3-4.584,6.2-4.827,10.281-.033.556-.048,1.039-.048,1.457,0,1.8.265,2.392.455,2.413a.782.782,0,0,0,.463.125,2.666,2.666,0,0,0,.712-.123l-.012.14c-.039.425-.077.856-.115,1.288q-.04.474-.079.952v.008c-.012.141-.023.281-.035.423l-.016.205c-.008.109-.017.217-.025.325",
    transform: "translate(0 533.387)",
    fill: "#686a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M505.1-324.184h0V-352.8h0v28.614",
    transform: "translate(0 533.387)",
    fill: "#ab8bb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "M505.1-273.657l-2.479-1.432V-405.1l2.48-1.432v132.874",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M458.075-379.415l-25.389,14.66a6.69,6.69,0,0,0-2.793,5.333v129.159l2.316,1.337,28.183-16.268V-378.077l-2.317-1.337",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    d: "M432.209-228.925l0,0V-358.087a6.672,6.672,0,0,1,.6-2.641v-.013l-2.3-1.327a6.588,6.588,0,0,0-.612,2.641v129.165l.921.535-.925-.535V-359.422a6.69,6.69,0,0,1,2.793-5.333l25.389-14.66,2.317,1.337v132.885l-5,2.888-6.017,3.472-3.9,2.249-2.464,1.423-10.8,6.236",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M432.807-360.742v.013a6.672,6.672,0,0,0-.6,2.641v129.163l-2.309-1.339V-359.427a6.588,6.588,0,0,1,.612-2.641l2.3,1.327",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path145",
    d: "M432.207-228.924l-2.309-1.339V-359.427a6.588,6.588,0,0,1,.612-2.641l2.3,1.327v.013a6.672,6.672,0,0,0-.6,2.641v129.163",
    transform: "translate(0 533.387)",
    fill: "#21246f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M435-363.419l25.389-14.658v132.885l-28.183,16.268V-358.086A6.689,6.689,0,0,1,435-363.419",
    transform: "translate(0 533.387)",
    fill: "#24277d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "M452.827-365l-12.018,6.94a5.581,5.581,0,0,0-2.323,4.428v107.585c0,1.709,1.047,2.5,2.323,1.761l12.018-6.941a5.585,5.585,0,0,0,2.321-4.44V-363.24c0-1.709-1.045-2.5-2.321-1.76",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M455.143-327.14v8.748l-16.654,21.369v-8.748l16.654-21.369",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    d: "M438.489-284.956l16.654-21.369V-282.5l-16.654,21.369v-23.822",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M532.276-421.349a1.765,1.765,0,0,0-1.784.159L505.1-406.531v132.873l2.317,1.336,28.17-16.266V-417.75a2.443,2.443,0,0,0-.959-2.237c-.405-.233-1.936-1.128-2.356-1.363",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    d: "M505.1-324.184h0v-82.347l25.389-14.66a2.194,2.194,0,0,1,1.095-.333,1.4,1.4,0,0,1,.689.175c.375.209,1.632.943,2.188,1.265a1.422,1.422,0,0,0-.551-.107,2.206,2.206,0,0,0-1.1.337L507.421-405.2l-2.317-1.336v82.347",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M535.591-417.75v129.161l-28.17,16.266V-405.2l25.389-14.658c1.531-.893,2.781.051,2.781,2.1",
    transform: "translate(0 533.387)",
    fill: "#20247b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "M526.991-407.8l-12.005,6.94a5.526,5.526,0,0,0-2.321,4.427v107.587c0,1.709,1.033,2.488,2.321,1.747l12.005-6.926a5.549,5.549,0,0,0,2.323-4.44V-406.05c0-1.709-1.033-2.488-2.323-1.747",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M512.663-324.541v-23.822l16.654-21.369v23.822l-16.654,21.369",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "M529.317-390.548v8.748l-16.654,21.369v-8.748l16.654-21.369",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M505.1-406.531l2.317,1.336v132.873l-2.317-1.336V-406.531",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "M507.421-323.645c-.405-.133-.82-.252-1.24-.357a7.811,7.811,0,0,0-1.077-.181v-82.347l2.317,1.336v81.55",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M169.578-212.743l-21.7,12.494V-85.455l-.005,18.093,47.028-27.13V-227.365l-25.327,14.622",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "M163.244-209.088v76.3a.788.788,0,0,1-.467.651,2.489,2.489,0,0,1-2.255,0,.79.79,0,0,1-.468-.651v-74.459l3.189-1.841",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M194.9-94.492l-16.3-9.416-30.717,17.7v18.843L194.9-94.492",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "M147.883-103.791v-18.834l14.4-8.286,16.312,9.415-30.711,17.705",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M178.594-121.494v17.588L147.883-86.2V-103.79l30.711-17.7",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "M168.824-189.93l26.082,15.062v79.142l-15.349-8.861v-17.586l-16.313-9.42v-55.116a3.72,3.72,0,0,1,5.58-3.221",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M194.906-140.1h0v0m0-33.535h0v-1.236h0v1.236m-2.481-1.433L167.861-189.25a3.681,3.681,0,0,0-1.855-.5,3.721,3.721,0,0,0-1.648.388,3.762,3.762,0,0,1,2.611-1.068,3.694,3.694,0,0,1,1.855.5l23.6,13.63v1.235",
    transform: "translate(0 533.387)",
    fill: "#efd6ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "M194.9-94.491l-16.31-9.416v-17.588l-16.313-9.419v-55.116a3.72,3.72,0,0,1,5.58-3.221l27.045,15.618v79.141",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M194.9-94.491h0l-8.689-5.017.612-9.852a1.418,1.418,0,0,0-.159-.684,1.377,1.377,0,0,0-.453-.536l-3.051-2.024c.515-.52,1.059-1.065,1.611-1.612,1.953-1.934,3.695-3.781,5.92-5.612.476,3.837,1.095,8.942,1.559,13.138l.024.212c.049.44.1.857.147,1.254v9.3l2.48,1.432m-22.177-30.39-10.446-6.032v-55.116a3.724,3.724,0,0,1,3.725-3.725,3.681,3.681,0,0,1,1.855.5l24.563,14.185V-140.1H179.686c-.208,1.019-4,9.125-6.958,15.216",
    transform: "translate(0 533.387)",
    fill: "#7274a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "M194.9-94.491v0m0-45.606h0v-33.535h0V-140.1",
    transform: "translate(0 533.387)",
    fill: "#ab8bb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M194.9-94.491l-2.48-1.432v-130.01l2.481-1.432V-94.491",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "M147.878-200.248l-25.389,14.66a6.687,6.687,0,0,0-2.794,5.333V-51.1l2.316,1.337,28.183-16.268V-198.911l-2.316-1.337",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M122.011-49.759l0,0v-129.16a6.693,6.693,0,0,1,.6-2.641v-.012l-2.3-1.328a6.587,6.587,0,0,0-.613,2.641V-51.1l.888.515-.892-.515V-180.255a6.687,6.687,0,0,1,2.794-5.333l25.389-14.66,2.316,1.337V-66.026L122.087-49.8l-.076.044",
    transform: "translate(0 533.387)",
    fill: "#484b9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "M122.607-181.574v.012a6.693,6.693,0,0,0-.6,2.641V-49.756L119.7-51.1V-180.261a6.587,6.587,0,0,1,.613-2.641l2.3,1.328",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M122.008-49.756,119.7-51.1V-180.261a6.587,6.587,0,0,1,.613-2.641l2.3,1.328v.012a6.693,6.693,0,0,0-.6,2.641V-49.756",
    transform: "translate(0 533.387)",
    fill: "#222677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "M124.805-184.251l25.388-14.66V-66.026L122.011-49.759V-178.92a6.685,6.685,0,0,1,2.794-5.332",
    transform: "translate(0 533.387)",
    fill: "#1e2275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M142.628-185.834l-12.018,6.94a5.58,5.58,0,0,0-2.322,4.428V-66.881c0,1.709,1.046,2.5,2.322,1.761l12.018-6.941a5.584,5.584,0,0,0,2.323-4.44V-184.074c0-1.709-1.047-2.5-2.323-1.76",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "M144.946-147.974v8.748L128.29-117.857V-126.6l16.656-21.37",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M128.29-105.789l16.656-21.369v23.823L128.29-81.966v-23.823",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "M222.078-242.183a1.762,1.762,0,0,0-1.784.16l-25.389,14.658V-94.492l2.316,1.337,28.17-16.268V-238.582a2.446,2.446,0,0,0-.959-2.239c-.405-.233-1.936-1.128-2.355-1.363",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M194.906-140.1h0v-87.268l25.389-14.658a2.182,2.182,0,0,1,1.093-.335,1.406,1.406,0,0,1,.691.175c.373.209,1.632.944,2.188,1.265a1.427,1.427,0,0,0-.551-.107,2.211,2.211,0,0,0-1.105.337l-25.389,14.66-2.316-1.337V-140.1",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "M225.393-238.582v129.159L197.222-93.155V-226.028l25.389-14.66c1.532-.893,2.783.051,2.783,2.105",
    transform: "translate(0 533.387)",
    fill: "#202375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M216.793-228.632l-12.005,6.941a5.523,5.523,0,0,0-2.323,4.427v107.586c0,1.709,1.033,2.488,2.323,1.748l12.005-6.928a5.548,5.548,0,0,0,2.321-4.44V-226.884c0-1.709-1.032-2.488-2.321-1.748",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "M202.464-145.374V-169.2l16.656-21.369v23.823l-16.656,21.369",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "M219.12-211.381v8.748l-16.656,21.369v-8.746l16.656-21.37",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "M194.906-227.365l2.316,1.337V-93.155l-2.316-1.337V-227.365",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M195-94.439l-.092-.054v-.224c.029.092.061.184.092.278m2.224-45.658h-2.316v-87.268l2.316,1.337V-140.1",
    transform: "translate(0 533.387)",
    fill: "#212574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "M484.6-306.015c.469.819,1.833.031,4.207-.823s1.7-11.357,1.7-11.357-3.756-.072-4.517,3.417-1.385,8.762-1.385,8.762",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "M485.259-305.671a.782.782,0,0,1-.463-.125h.011c.084,0,.151-.115.169-.284.068-.639.684-7.308,1.764-9.066.225-.367.412-.687.591-.952-.056.24-.111.5-.167.793-.009.051-.02.1-.029.156s-.017.1-.027.144c0,.024-.008.047-.013.071-.047.26-.093.537-.14.828-.1.632-.2,1.332-.3,2.085-.028.208-.055.42-.083.636-.056.448-.112.915-.168,1.392-.037.333-.076.675-.113,1.02-.043.389-.084.787-.125,1.189-.065.651-.129,1.316-.192,1.989a2.665,2.665,0,0,1-.712.123",
    transform: "translate(0 533.387)",
    fill: "#171a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "M504.583-323.889c2.217.017,7.05,2.693,7.786,4.437.771,1.828,3.1,26.39,1.157,28.634-2.439,2.815-14.232,8.157-19.336,7.87-4.211-.237-8.124-4.2-8.738-5.344-1.007-1.872.931-27.045,2.32-29.135,2.252-3.388,13.986-6.485,16.81-6.463",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M494.6-282.937c-.141,0-.279,0-.411-.011a10.838,10.838,0,0,1-5.4-2.1,12.8,12.8,0,0,1-3.315-3.2,14.323,14.323,0,0,0,6.135,4.713l.187.037a2.056,2.056,0,0,0,.423.045c4.18,0,3.195-14.457,3.26-16.064l.028-1.189.248-9.736h.053c.051,0,.105,0,.167-.008,11.673-.477,16.692-6.562,16.833-6.737a175.929,175.929,0,0,1,1.472,20.18c0,3.16-.209,5.556-.756,6.188a5.33,5.33,0,0,1-.425.432l-16.733-2.671c-.412,3.695-.944,6.209-1.1,8.909q-.032.594-.048,1.189c-.215.013-.423.021-.621.021",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path189",
    d: "M485.477-288.249l0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M485.473-288.255a0,0,0,0,1,0,0,0,0,0,0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "M485.464-288.271h0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M485.461-288.278a0,0,0,0,1,0,0,0,0,0,0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path193",
    d: "M485.457-288.285h0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M485.451-288.3h0",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path195",
    d: "M485.236-289.5c0-.032,0-.064-.007-.1,0,.032.005.064.007.1",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M485.224-289.686c-.007-.1-.012-.2-.017-.3l.017.3m.376-11.557c.02-.293.043-.588.064-.881-.015.207-.031.412-.045.619-.007.087-.013.175-.019.263m.131-1.74c.012-.141.023-.281.035-.423-.012.141-.023.281-.035.423m.113-1.383c.037-.432.076-.863.115-1.288q-.044.482-.087.971l-.028.317m.557-5.626c.056-.477.112-.944.168-1.392l-.02.167c-.051.4-.1.807-.148,1.225m.251-2.028c.1-.753.2-1.453.3-2.085-.023.137-.044.277-.067.421-.069.448-.137.925-.205,1.428-.011.079-.02.156-.031.236m.456-2.984c.009-.048.017-.1.027-.144-.009.048-.017.1-.027.144",
    transform: "translate(0 533.387)",
    fill: "#8e50ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path197",
    d: "M485.872-304.683c.091-1.053.189-2.095.291-3.1.041-.4.083-.8.125-1.189.084-.78.172-1.532.261-2.245q.066-.534.133-1.039c.068-.5.136-.98.205-1.428s.137-.867.207-1.249c.024-.128.047-.251.069-.371a7.442,7.442,0,0,1,.609-2.123l.216-.288.08-.095.176-.195.111-.113.191-.183.124-.115.308-.259.215-.167.147-.111.251-.18.127-.087.291-.2c1.968.877,3.829,1.709,3.884,1.748a4.8,4.8,0,0,1,1.939,4.44l-.32,12.521-.028,1.189c-.068,1.659.987,17.014-3.683,16.018l-.187-.037a14.192,14.192,0,0,1-6.16-4.757,2.657,2.657,0,0,1-.184-.844c-.017-.163-.033-.345-.045-.547l-.017-.313c-.015-.327-.025-.692-.029-1.091,0-.133,0-.271,0-.411-.007-2.1.113-5.011.315-8.122.04-.623.083-1.253.129-1.887.031-.423.063-.848.1-1.272.016-.212.033-.424.051-.636.035-.424.069-.848.107-1.269",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M495.812-310.44h-.044l.211-.008c-.061.005-.116.008-.167.008",
    transform: "translate(0 533.387)",
    fill: "#503364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path199",
    d: "M495.758-310.44a.527.527,0,0,1-.157-.029,74.961,74.961,0,0,1-8.28-5.571l0-.005.012-.053c.36-.531.684-.837,1.212-.837a7.025,7.025,0,0,1,3.02,1.357,9.228,9.228,0,0,1,4.2,5.139",
    transform: "translate(0 533.387)",
    fill: "#1d217a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M484.825-299.737c.135-.064,2.116-1.461,2.344-1.569.4-.189,6.043,3.872,6.556,4.548.356.471-.429,7.564-.669,8.064-.088.18-2.259,1.391-2.345,1.569-.24.5-6.2-3.635-6.55-4.6s.073-7.729.665-8.008",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    d: "M490.71-287.125a47.821,47.821,0,0,0,.761-7.245,2.017,2.017,0,0,0-.091-.819,0,0,0,0,1,0,0l2.344-1.568h0a2.017,2.017,0,0,1,.091.819,47.682,47.682,0,0,1-.76,7.245c-.088.18-2.259,1.391-2.345,1.569m-6.677-6.243h0a33.127,33.127,0,0,1,.467-5.548h0a33.139,33.139,0,0,0-.467,5.548",
    transform: "translate(0 533.387)",
    fill: "#8b47a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "M491.381-295.189c.356.471-.429,7.564-.671,8.064s-6.2-3.635-6.55-4.6.073-7.729.665-8.008c.4-.189,6.043,3.872,6.556,4.548",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path203",
    d: "M491.38-295.19a2.734,2.734,0,0,0-.3-.3,1.918,1.918,0,0,1,.359-.456,4.222,4.222,0,0,1,2-.884.5.5,0,0,1,.291.073h0l-2.344,1.568",
    transform: "translate(0 533.387)",
    fill: "#502e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M490.617-287.083c-.8,0-6.126-3.731-6.457-4.645a6.52,6.52,0,0,1-.127-1.639,33.139,33.139,0,0,1,.467-5.548v.065a11.165,11.165,0,0,0,.481,3.02c.359,1.135,2.069,2.895,3.464,2.895a1.483,1.483,0,0,0,.317-.033c1.151-.247,1.808-1.711,2.315-2.523a2.619,2.619,0,0,1,.3.3h0a0,0,0,0,0,0,0,2.017,2.017,0,0,1,.091.819,47.821,47.821,0,0,1-.761,7.245c-.013.028-.045.041-.093.041",
    transform: "translate(0 533.387)",
    fill: "#13154f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path205",
    d: "M491.38-295.19a2.614,2.614,0,0,0-.3-.3h0a2.734,2.734,0,0,1,.3.3h0",
    transform: "translate(0 533.387)",
    fill: "#422752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "M493.724-296.758c-.419-.292-1.72.352-2.288.811s-1.235,2.669-2.673,2.979-3.4-1.639-3.781-2.861-.811-3.779-.091-4.664a2.341,2.341,0,0,1,2.933-.767c.995.576,5.812,3.387,5.9,4.5",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "M488.445-292.935c-1.395,0-3.105-1.76-3.464-2.895a11.165,11.165,0,0,1-.481-3.02,2.721,2.721,0,0,1,.391-1.644,2.639,2.639,0,0,1,1.977-1.023,1.876,1.876,0,0,1,.956.256c.995.576,5.812,3.387,5.9,4.5a.5.5,0,0,0-.291-.073,4.222,4.222,0,0,0-2,.884,1.917,1.917,0,0,0-.359.456h0c-.507.812-1.164,2.276-2.315,2.523a1.484,1.484,0,0,1-.317.033",
    transform: "translate(0 533.387)",
    fill: "#1b1e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M487.267-295.969a1.062,1.062,0,0,1,.465,1,.428.428,0,0,1-.664.357,1.038,1.038,0,0,1-.465-1c.055-.38.352-.539.664-.356",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path209",
    d: "M495.758-310.44a9.213,9.213,0,0,0-4.2-5.139c-3.5-2.169-3.623-1.523-4.823.433-1.08,1.759-1.7,8.428-1.764,9.066s-.831.493-.587-3.588.937-7.977,4.827-10.281c5.236-3.1,13.246-4.985,16.965-4.055s7.021,2.915,6.633,6.813c0,0-5.056,6.335-17.056,6.749",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M484.807-305.8c-.189,0-.465-.58-.465-2.415,0-.419.015-.9.048-1.457.243-4.083.937-7.977,4.827-10.281a32.768,32.768,0,0,1,14.67-4.293,9.661,9.661,0,0,1,2.295.239c3.515.88,6.658,2.7,6.664,6.191a5.849,5.849,0,0,1-.031.623s-4.993,6.257-16.836,6.741l-.211.008h-.009a9.228,9.228,0,0,0-4.2-5.139,7.024,7.024,0,0,0-3.02-1.357c-.528,0-.852.307-1.212.837h0c-.179.265-.365.585-.591.952-1.08,1.759-1.7,8.428-1.764,9.066-.019.169-.085.284-.169.284",
    transform: "translate(0 533.387)",
    fill: "#5d60ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path211",
    d: "M534.389-276.878a8.845,8.845,0,0,1,.968.187.906.906,0,0,0,1-.391c.176-.416-.189-.848-.521-1.153-1.8-1.645-3.657-3.452-4.229-5.82a3.82,3.82,0,0,1,1.529,1.189,4.249,4.249,0,0,0,1.136.995,1.472,1.472,0,0,0,1.448.023l.127-.14-.061-.231c-.811-1.392-1.812-2.7-2.712-4.037a11.056,11.056,0,0,0-1.008-1.345c-.821-.889-2.287-1.78-2.748-2.9-.132-.32-3.948-10.1-3.948-10.1s-6.616,3.436-6.533,3.616c.672,1.468,6.316,11.4,6.873,12.914.811,2.208,1.46,4.28,3.183,5.936a3.309,3.309,0,0,0,2.037.987,3.6,3.6,0,0,1,.867.071,5.561,5.561,0,0,1,.6.292,1.687,1.687,0,0,0,1.045.111,6.684,6.684,0,0,1,.779-.2l.169,0",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M518.758-296.173a11.3,11.3,0,0,0,7.063-3.267l-.655-1.993s-.567-3.571-1.052-9.282c-.592-6.956-3.225-8.992-7.092-9.492l-1.747,10.469s.951,4.467,1.767,8.786a10.5,10.5,0,0,0,1.716,4.779",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "M521.016-290.6,505.2-289.189l1.515,25.665a34.617,34.617,0,0,0-6.56,7.322c-1.8,2.9-7.826,13.581-8.854,15.42a23.583,23.583,0,0,1-1.832,2.712c-.375.492-.888.713-1.051,1.3-.717,2.595.868,6.877,2.429,9.118a5.865,5.865,0,0,0,1.545,1.58,3.416,3.416,0,0,0,2.127.6,1.4,1.4,0,0,0,1.14-.605,1.687,1.687,0,0,0,.109-.967,30.825,30.825,0,0,1-.279-3.617c.069-2.563,1.741-4.985,3.493-6.84,2.319-2.453,17.254-19.565,18.125-20.753,1.307-1.781,2.733-3.265,3.308-9.416.584-6.244,1.016-19.732.6-22.935",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "M521.755-290.4s1.556,11.665,2.016,22.161c.269,6.13-.449,7.88-2.105,10.133-2.064,2.805-5.468,5.547-8.9,8.68-4.077,3.72-13.082,11.562-14.557,13.06,0,0-4.788-1.5-6.743-5.3,0,0,3.237-6.63,6.248-11.86s5.957-9.254,5.957-9.254l-4.392-24.327,22.477-3.295",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path215",
    d: "M493.368-239.437l-.429-.176c2.236-5.217,10.829-19.819,14.182-22.459l.295.349c-3.237,2.549-11.884,17.236-14.048,22.286",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M492.942-244.737c.672,1.749,5.184,6.3,7.453,6.065l-2.747,2.957c-2.064-.052-5.476-3.253-6.486-5.487l1.78-3.536",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path217",
    d: "M499.28-287.108h0l4.392,24.327s-1.273,1.756-2.9,4.26l-.2.313-.177.276c-.445.7-.919,1.453-1.4,2.251,0,.016.657,3.816.689,3.988.107.568-1.505,2.74-1.055,9.681.088,1.337.437,3.288.637,4.541a3.087,3.087,0,0,1,.753-.58c3.227-2.923,9.528-8.437,12.75-11.378q.746-.68,1.484-1.336a85.276,85.276,0,0,0,.476-9.113c-.127-2.736-1.215-16.393-1.215-16.393a11.386,11.386,0,0,0,3.325-2.54,7.247,7.247,0,0,0,1.681-2.949,44.49,44.49,0,0,0,2.007-5.3l-21.243-.049",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M486.02-235.161c-.356-.117-.815,1.12-.9,1.527a10.156,10.156,0,0,0,.836,3.1,14.594,14.594,0,0,1,1.379,3.58c.22,1.347-.1,3.811.833,5.755a9.1,9.1,0,0,0,7.345,4.527,5.076,5.076,0,0,0,2.931-.631,1.682,1.682,0,0,0,.633-1.26l-13.056-16.6",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "M488.21-226.086a9.488,9.488,0,0,0-1.108-3.735c-.668-1.477-1.756-3.425-1.492-5.04a5.431,5.431,0,0,1,2.264-2.379c1.209-.756,1.505-1.817,2.147-1.557l-.3.4a18,18,0,0,0,1.324,2.4,1.331,1.331,0,0,1,.159,1.159,3.706,3.706,0,0,0,.011,2,6.345,6.345,0,0,1,.481-1.181,1.278,1.278,0,0,1,.913-.7,3.668,3.668,0,0,1,2.316.608c.8.431,1.768.821,2.091,1.495.275.573-.315,1.325-.593,1.795-.768,1.3-.369,2.916-.019,4.279a15.732,15.732,0,0,0,1.912,4.776c.907,1.255,1.613,1.876.764,3.2a2.594,2.594,0,0,1-1.233.9,4.126,4.126,0,0,1-1.516.251,8.805,8.805,0,0,1-5.8-2.153,6.911,6.911,0,0,1-1.669-2.5,12.114,12.114,0,0,1-.643-4.023",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M497.53-223.17a8.065,8.065,0,0,0,.781,1.409c.907,1.255,1.613,1.876.764,3.2a2.594,2.594,0,0,1-1.233.9,4.154,4.154,0,0,1-1.516.251,8.805,8.805,0,0,1-5.8-2.153,6.186,6.186,0,0,1-1.432-2c.052-1.579,5.012-2.921,8.44-1.608",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path221",
    d: "M510.187-220.737c.128-2.631.356-4.7.535-7.1q.362-4.84.747-9.68.392-4.962.792-9.921c.212-2.636-.212-5.015,0-7.65a173.708,173.708,0,0,0-1.709-22.558,15.828,15.828,0,0,0,5.372-3.625c4-3.968,4.556-7.77,4.556-7.77l-1.853-.432-20.414-2.544c-.48,3.248-1.365,7.773-1.608,12.044-.5,8.758,5.6,25.41,5.6,25.41-.28,1.175-2.008,6.064-1.489,10.669.817,7.264.988,15,1.172,18.922s.524,6.129.327,6.872c-.147.549-.547,1.419-.339,1.852.28.581.764.86,1.42,1.684a29.251,29.251,0,0,0,2.424,2.7,8.35,8.35,0,0,0,2.68,1.721,6.966,6.966,0,0,0,3.937.661c.457-.095,1.48-.316,1.579-.757a1.387,1.387,0,0,0-.3-.98c-1.183-1.949-1.341-2.136-2.479-4.109-1.475-2.56-1.033-3.632-.947-5.412",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "M496.369-293.057c-.412,3.695-.944,6.209-1.1,8.909A46.877,46.877,0,0,0,496-273.526c.657,3.892,4.625,20.153,4.884,21.53a30,30,0,0,0-.871,11.87c.792,9.3,1.977,17.554,1.977,17.554s5.425,1.363,8.578-.143c0,0,2.951-25.822,3.2-31.849.219-5.236-1.729-22.629-1.729-22.629a15.1,15.1,0,0,0,9.688-11.816l-25.365-4.049",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path223",
    d: "M504.378-222.01q-.248-.04-.476-.084c-.005-.041-.011-.083-.015-.124.152.021.309.043.473.063.005.049.011.1.017.145",
    transform: "translate(0 533.387)",
    fill: "#c6717d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M504.361-222.156c-.164-.02-.321-.041-.473-.063-.569-4.895-1.552-13.69-1.8-18.146a36.389,36.389,0,0,1,.605-9.5,10.584,10.584,0,0,0,.263-3.735c-.175-1.056-.747-3.828-1.408-7.037-1.225-5.937-2.749-13.326-3.219-16.749-.564-4.115.207-12.482.215-12.566l.463.044c-.008.084-.775,8.4-.217,12.466.468,3.409,2.055,11.1,3.213,16.721.689,3.347,1.235,5.989,1.412,7.055a11.027,11.027,0,0,1-.265,3.883,35.96,35.96,0,0,0-.6,9.4c.247,4.479,1.24,13.361,1.807,18.229",
    transform: "translate(0 533.387)",
    fill: "#2e3f48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path225",
    d: "M501.474-226.5c1.684,1.027,7.852,1.475,9.536-.1l-.4,3.98c-1.7,1.216-6.428,1.319-8.7.1l-.436-3.985",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M501.4-213.16a1.968,1.968,0,0,0-.009,1.387,4.682,4.682,0,0,0,1.743,1.5c.949.6,2.32.988,3.179,2.331a11.853,11.853,0,0,0,3.856,4.248,9.583,9.583,0,0,0,7.49,1.049c2.623-.815,2.883-1.917,2.855-2.884L501.4-213.16",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path227",
    d: "M511.745-216.661a2.75,2.75,0,0,0,.539,1.271,19.627,19.627,0,0,0,3.153,3.624,35.409,35.409,0,0,0,3.695,3.151c1.065.8,1.765,1.647,1.705,2.359-.188,2.216-2.941,3.2-5.761,3.12a9.073,9.073,0,0,1-4.708-1.461,9.224,9.224,0,0,1-2.131-2.109c-1.236-1.685-1.464-2.563-2.961-3.471-1.268-.769-2.7-.952-3.92-2.789-.456-1.232.139-2.544.336-3.785a12.782,12.782,0,0,0,.027-1.692.681.681,0,0,1,.536-.691l.035.551a2.188,2.188,0,0,0,.924.813c.669.341,1.293.048,1.731.615a4.142,4.142,0,0,1,.427.863,4.257,4.257,0,0,0,.7,1.131,6.633,6.633,0,0,1-.181-1.155c.012-.624-.029-1.043.311-1.261a7.9,7.9,0,0,1,1.587-.643,10.268,10.268,0,0,1,2.4-.489,1.264,1.264,0,0,1,1.385.444,3.447,3.447,0,0,1,.169,1.555v.052",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M517.815-209.677c.511.42,1.024.827,1.521,1.2,1.065.8,1.767,1.645,1.705,2.359-.188,2.215-2.941,3.2-5.761,3.119a9.074,9.074,0,0,1-4.708-1.46,6.1,6.1,0,0,1-.552-.416c-.123-1.6,3.149-5.035,7.794-4.8",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path229",
    d: "M496.114-318.569s-.324,5.737-.748,11.4a72.847,72.847,0,0,0-.267,10.722c.216,4.083-.1,12.129-.1,12.129,4.408,3.291,23.149,2.323,27.1-3.289-.291-3.556-.521-7.246-.461-10.473.072-3.947.917-10.67.1-14.261a14.7,14.7,0,0,0-4.713-7.864,43.818,43.818,0,0,0-10.821-.857,39.177,39.177,0,0,0-10.086,2.495",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "M508.059-321.148a18.069,18.069,0,0,0-1.859.084,39.177,39.177,0,0,0-10.086,2.495s-.324,5.737-.748,11.4a72.847,72.847,0,0,0-.267,10.722c.216,4.083-.1,12.129-.1,12.129,1.673,1.249,5.417,1.885,9.63,1.885,6.88,0,15.017-1.695,17.465-5.175-.291-3.556-.521-7.246-.461-10.473.072-3.947.917-10.67.1-14.261a14.7,14.7,0,0,0-4.713-7.864,51.493,51.493,0,0,0-8.962-.941Zm0,.576a50.7,50.7,0,0,1,8.737.908,14.361,14.361,0,0,1,4.377,7.449c.564,2.469.311,6.53.087,10.112-.091,1.468-.177,2.855-.2,4.011-.064,3.443.2,7.3.447,10.316-2.427,3.131-10.266,4.767-16.874,4.767-4.109,0-7.445-.6-9.044-1.605.055-1.536.275-8.262.085-11.864a71.333,71.333,0,0,1,.251-10.47l.013-.179c.36-4.8.651-9.7.729-11.049a39.51,39.51,0,0,1,9.592-2.315,17.628,17.628,0,0,1,1.8-.08",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path231",
    d: "M505.522-324.449a20.686,20.686,0,0,1-4.095-6.512c-.487-1.255-1.3-4.351-.927-6.015a2.976,2.976,0,0,1,2.121-2.316,3.455,3.455,0,0,1,1.045-3.336,2.6,2.6,0,0,1,2.672-.672,2.281,2.281,0,0,1,1.449-1.876,2.28,2.28,0,0,1,2.319.492,2.348,2.348,0,0,1,2.284-1.309,2.565,2.565,0,0,1,2.252,1.635,4.063,4.063,0,0,1,2.463-1.111,2.383,2.383,0,0,1,2.265,1.268,3.824,3.824,0,0,1-.117,2.619,1.38,1.38,0,0,1,1.492-.128,1.381,1.381,0,0,1,.685,1.332,3.851,3.851,0,0,0-.161,1.024.813.813,0,0,0,.576.643.811.811,0,0,0,.821-.261,1.7,1.7,0,0,1-.371,1.564,1.7,1.7,0,0,1-1.519.528,1.287,1.287,0,0,1-.455,1.3,1.5,1.5,0,0,1-1.068.236l-13.733,10.9",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M519.518-327.024c-.385,2.3-1.255,3.388-2.781,3.995a7.592,7.592,0,0,1-2.551.361l-.152,1.88c4.729,5.217-6.593,5.071-8.9.445l.191-6.641a1.952,1.952,0,0,1-2.624.225,3.573,3.573,0,0,1-1.383-4.3,1.756,1.756,0,0,1,2.9-.668c.529.488,1.148,1.325,1.583,1.268.671-.091.805-.661.941-1.091a9.155,9.155,0,0,0,.323-3.348c.437-.259,1.044-.513,1.208-1.059a3.361,3.361,0,0,0-.523-3.361c1.7-1.263,4.395.752,6.368.908,2.26.18,2.705-1.131,3.937-1.035a11.045,11.045,0,0,1,1.272,3.888,26.438,26.438,0,0,1,.192,8.53",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path233",
    d: "M514.186-322.667v0c-1.8.011-4.405-.244-5.963-1.641a6.726,6.726,0,0,1-1.961-3.344,9.648,9.648,0,0,0,1.1,3.577,7.1,7.1,0,0,0,3.78,2.263,26.08,26.08,0,0,0,2.953.271l.091-1.123",
    transform: "translate(0 533.387)",
    fill: "#f57585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M518.347-335.494l-1.784-.429a.879.879,0,0,1,1.075-.692.963.963,0,0,1,.709,1.121",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path235",
    d: "M510.537-334.4l1.616-.919a.892.892,0,0,0-1.24-.373.978.978,0,0,0-.376,1.292",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M517.15-330.545l-2.493.92L514-334.464c.893-.18,2.289,2.232,3.152,3.919",
    transform: "translate(0 533.387)",
    fill: "#f57585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path237",
    d: "M512.7-328.788l2.577.892a1.368,1.368,0,0,1-1.859.793,1.282,1.282,0,0,1-.719-1.685",
    transform: "translate(0 533.387)",
    fill: "#a85361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "M514.163-327.009a1.43,1.43,0,0,0-1.411-1.3l-.132.012a1.2,1.2,0,0,0,.8,1.2,1.547,1.547,0,0,0,.747.093",
    transform: "translate(0 533.387)",
    fill: "#f57585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "M511.269-332.882a.773.773,0,0,0,.772.773.773.773,0,0,0,.773-.773.773.773,0,0,0-.773-.773.773.773,0,0,0-.772.773",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M516.82-333.481a.772.772,0,0,0,.773.773.772.772,0,0,0,.772-.773.772.772,0,0,0-.772-.772.772.772,0,0,0-.773.772",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path241",
    d: "M501.818-320.336a19.511,19.511,0,0,1,4.537,11.4c1.193,18.022-11.546,21.545-11.546,21.545s-.232-3.711-.433-6.74c0,0,9.082-4.848,8.492-14.054-.42-6.565-3.436-10.561-5.089-11.033a26.126,26.126,0,0,1,4.04-1.121",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "M492-287.419a12.04,12.04,0,0,0,4.689-2.795c3.332-2.877,3.523-3.313,6.294-5.857.94-.863,1.783-1.724,2.181-2.112a10.92,10.92,0,0,0,2.1-2.18,6.707,6.707,0,0,0,1.171-2.525,9.362,9.362,0,0,0,.251-2.949c-.059-.287-.156-.564-.2-.852a6.612,6.612,0,0,1-.02-1.205,5.782,5.782,0,0,0-.293-2.081,3.674,3.674,0,0,0-.975-1.467,1.279,1.279,0,0,0-1.264-.416c.112.521.192.961.288,1.572a4.4,4.4,0,0,1-1.053,2.323c-1.035,1.407-1.931,2.141-2.067,1.863-.145-.3.251-1.157.088-2.568-.156-1.348-.557-1.913-.991-2.015-.692-.163-.673.583-.943,1.716-.32,1.351-.889,2.1-.927,4.088-.032,1.741.259,2.14-.7,2.936-.549.456-2.425,1.543-2.425,1.543s.5-1.9,1.319-5.152c1.592-6.305,1.031-11.4-.723-13.661-2.593.981-6.048,2.648-7.533,7.79-1.58,5.468-1.609,6.289-3.121,17.126-1.1,7.886,2.219,7.714,4.859,6.878",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path243",
    d: "M497.8-319.215c-3.4.812-5.312,2.081-6.433,4.239-1.713,3.3-2.405,6.2-2.975,10.636-.72,5.607-2.521,13.592-.961,16.048,1.213,1.911,3.632,1.625,5.348.6-1.932-5.527-.38-9.888,4.425-12.712,0,0,1.655-5.023,2.345-7.621s.863-9.253-1.749-11.192",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    d: "M497.2-300.4c-2.195,1.688-7.014,4.155-7.6,6.8,0,0,.049-2.095,2.94-4.656a39.547,39.547,0,0,1,5.115-3.908L497.2-300.4",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path245",
    d: "M370.344-102.459c-.277-1.483,1.176-2.36,1.876-3.181a8.17,8.17,0,0,0,1.5-4.836c.063-1.94.343-3.316-.757-5.112-1.3-2.126-3.133-4.628-9.348-10.814l8.54-4.042c1.557,2.752,5.107,8.428,5.107,8.428l.327.5a10.485,10.485,0,0,0,2.333,2.661l.432.249c.736.561,2.64,1.2,2.533,3.056s-.828,2.29-1.7,3.782a5.646,5.646,0,0,0-1.067,3.284c-.091,1.494-.019,2.143-.056,3.481a4.206,4.206,0,0,1-3.235,3.382c-3.1.956-6.212.62-6.484-.839",
    transform: "translate(0 533.387)",
    fill: "#91545d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "M383.973-115.459a21.176,21.176,0,0,1,2.133,4.161l-2.231,2.973-1.649-3.143a11.312,11.312,0,0,0,1.747-3.992",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "M383.876-108.324l-2.888-.312a2.615,2.615,0,0,1,.359-1.835,3.736,3.736,0,0,1,.88-1l1.649,3.143",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    d: "M383.418-116.168a2.126,2.126,0,0,1,.535.643,5.618,5.618,0,0,1-.745,3.12,9.173,9.173,0,0,0-1.953,3.161c-.295,1.311.169,3.35-.413,5.175s-2.388,3.869-6.165,4.228c-2.7.256-3.692-.306-4.567-.918-.277-1.208-.235-1.519,1.273-2.474s12.036-12.934,12.036-12.934",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path249",
    d: "M378.609-121.221a9.572,9.572,0,0,0,2.637,2.81,5.056,5.056,0,0,1,2.172,2.243c.208,1.607-.131,2.257-1.633,4.248a6.111,6.111,0,0,0-1.433,4.192c-.059,2.328.7,3.455-2.139,5.733-2.211,1.776-6.892,1.726-8.11.392-.961-3.214,1.813-2.884,2.6-6.223a12.19,12.19,0,0,0,.344-5.774,6.608,6.608,0,0,0-.8-1.8c-.313-.512-1.261-1.664-.692-2.273l.387.547a4.512,4.512,0,0,0,3.3-.931c2.7-2.076,2.345-3.46,2.345-3.46l-.327-.5c.277-.319.7-.069,1.348.795",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M362.134-157.872,355.8-166.52s-8.745-4.717-12.01-8.053a35.237,35.237,0,0,0-1.239,17.78,46.766,46.766,0,0,0,9.965,20.809c2.7,3.16,16.672,15.585,16.672,15.585,1.4-.2,5.311-3.274,5.8-5.293,0,0-3.06-5.481-4.868-8.3-2.361-3.677-3.055-5.435-7.485-8.522.353-3.779-.5-15.36-.5-15.36",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path251",
    d: "M373.18-126.054l.287-.183-.172-.269c-4.249-6.648-8.288-12.822-17.7-14.841l-.072.332c9.274,1.989,13.272,8.1,17.486,14.692l.172.269",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M365.636-140.118q-.218-.208-.459-.42l-.192-.168q-.228-.2-.476-.4l-.229-.185c-.173-.139-.359-.281-.548-.424l-.231-.176c-.273-.2-.559-.408-.867-.623.015-.155.027-.328.037-.508l.008-.139c.008-.171.016-.349.021-.539l0-.048c.005-.208.009-.429.012-.656l0-.157c0-.212,0-.428,0-.653v-.067c0-.253,0-.516-.007-.783l0-.132c0-.255-.009-.512-.015-.775v-.048q-.01-.444-.024-.9v-.029q-.014-.452-.032-.911v-.012l-12.33-10.308c-.056-.269-5.877-4.049-5.877-4.049.423,3.7,4.223,5.405,4.223,5.405l-1.3,14.261c.076.128,1.091,1.887,1.167,2.012.091.147.18.295.269.439.145.232.289.455.432.676l.217.336c.207.313.412.615.613.9l.219.308c.135.192.269.381.4.561l.237.321c.123.164.243.324.36.477l.22.284q.188.24.365.46l.167.208c.169.208.335.407.489.587,1.451,1.7,6.173,6.089,10.222,9.777a44.584,44.584,0,0,0-.189-5.836l3.185-7.984-.1-.091",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path253",
    d: "M376.107-123.873s.132,1.753-2.177,3.552a5.587,5.587,0,0,1-3.663,1.244l-2.729-2.672s1.453.393,3.736-1.574a7.065,7.065,0,0,0,2.5-4.637l2.332,4.088",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M350.975-93.754c-.732,2.145-3.259,2.62-5.24,1.964-1.119-.37-1.656-1.638-2.364-2.48a9.692,9.692,0,0,0-4.105-2.526,16.245,16.245,0,0,1-4.372-2.108,6.966,6.966,0,0,1-2.312-3.34,2.735,2.735,0,0,1-.148-1.293,2.356,2.356,0,0,1,2.391-1.68,7.788,7.788,0,0,1,3.021.887,38.987,38.987,0,0,0,4.015,1.485,4.54,4.54,0,0,0,1.316.261,2.632,2.632,0,0,0,2.052-1.159c.431-.964.921-11.672.915-12.169l10.21,2.586s-3.829,11.569-4.439,13.521a4.541,4.541,0,0,0-.131.581c-.311,1.816-.207,3.706-.809,5.469",
    transform: "translate(0 533.387)",
    fill: "#91545d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path255",
    d: "M365.315-173.817c3.483,7.245,4.776,10.09,3.327,17.39-.987,4.971-4.147,13.237-7.947,24.383.267,6.392-.693,8.324-2.048,12.771-2.072,6.8-4.577,12.865-4.577,12.865s-1.793-2.842-8.389-2.458c.408-6.429.785-19.045,1.321-23.7.8-6.918,3.055-26.673,3.055-26.673s-8.249-1-8.249-14.574h23.507",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M351.818-108.048a122.879,122.879,0,0,0,3.971-11.839,46.1,46.1,0,0,0,1.489-8.575c.108-1.719.131-3.835.169-4.582a60.4,60.4,0,0,1,3.117-13.418,88.3,88.3,0,0,0,3.177-13.286l-.172.011a3,3,0,0,1-1.888-.677c-1.7-1.339-2.865-4.6-3.452-9.7l.339-.039c.568,4.935,1.717,8.21,3.324,9.473a2.65,2.65,0,0,0,1.9.592c.708-4.865-.544-8.354-1.653-11.434-.284-.789-.549-1.539-.783-2.292h.359c.223.712.475,1.425.745,2.177,1.132,3.145,2.416,6.712,1.652,11.734a85.16,85.16,0,0,1-3.228,13.552,62.02,62.02,0,0,0-3.1,13.328c-.037.727-.063,2.845-.171,4.538a42.788,42.788,0,0,1-1.517,8.6c-.855,3.233-2.515,8.249-3.973,11.987l-.308-.148",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path257",
    d: "M333.189-105.649c.907-.951,2.735-.324,3.912.153,2.487,1.009,3.237,1.7,5.08,2.049,2.671.511,2.587-1.02,2.587-1.02s1.945-1.412,5.4.472c2.451,1.339,2.429,3.078,2.429,3.078a11.765,11.765,0,0,0-.816,4.077,9.9,9.9,0,0,1-.636,4l-11.132-7.281-.793-.187c-2.407-1.309-6.027-5.341-6.027-5.341",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M331.825-103.832a2.047,2.047,0,0,1,.7-1.4c.128-.092.577-.356.664-.419,1.144-.824,3.343.721,5.207,2.254,2.172,1.785,5.937,2.046,7.744,4.527s3.945,3.367,4.689,4.463a1.866,1.866,0,0,1-.087,2.3c-.1.123-.48.511-.555.591a3.05,3.05,0,0,1-2.66.652A8.245,8.245,0,0,1,341.4-94.5c-2.061-2.65-4.441-1.279-6.777-2.931a6.477,6.477,0,0,1-2.8-6.4",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path259",
    d: "M331.825-103.832c.523-3.132,3.495-1.122,5.907.859,2.172,1.785,5.936,2.047,7.744,4.528s3.993,3.333,4.689,4.462c1.264,2.052-.284,3.459-2.637,3.124A8.245,8.245,0,0,1,341.4-94.5c-2.061-2.65-4.441-1.279-6.777-2.931a6.477,6.477,0,0,1-2.8-6.4",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    d: "M340.229-96l5.247-2.449c1.807,2.481,3.993,3.333,4.689,4.462a6.564,6.564,0,0,1,.777,1.59l-.815,1.774-.276.3-.007.008h0a3.065,3.065,0,0,1-2.644.639,8.251,8.251,0,0,1-6.127-3.645c-.425-.548-.809-1.039-1.172-1.492L340.229-96",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path261",
    d: "M349.837-92.8c1.264,2.052-.283,3.459-2.637,3.124a8.251,8.251,0,0,1-6.127-3.645c-.425-.548-.809-1.039-1.172-1.492l5.247-2.449c1.808,2.481,3.995,3.333,4.689,4.462",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M355.476-110.009l-1.719,4.55s-2.167-2.662-8.133-2.257l.28-4.995s5.889-1.221,9.572,2.7",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path263",
    d: "M365.619-173.7c-.577-1.813-2.173-2.528-2.309-7.076-.068-2.252.013-7.418.013-7.418s-3.993-2.307-4.248-11.016l-4.349-.933-2.351-.4-6.152,1.329-3.031,1.421a25.307,25.307,0,0,0-3.885,5.5c-1.752,3.676-1.545,7.353,1.289,9.637.116.519.9,8.6.629,10.674a3.848,3.848,0,0,0,.672,2.808c2.928,3.348,17.4,4.968,23.721-4.525",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "M304.371-203.459c-.551-.117-.656.408-.316.8.809.935,2.321.883,3.037,1.273.167.115,2.164,1.944,2.219,2.5-.565-.252-2.281-1.185-2.859-1.405-.167-.064-.643-.155-2.1-.423a2.079,2.079,0,0,0-.765-.068c-.175.052-.357.424-.036.792.576.657,1.625.632,2.436.957a3.881,3.881,0,0,1,1.993,1.477,9.067,9.067,0,0,0-3.827-.135c-.216.02-.255.133-.244.275a.75.75,0,0,0,.409.556,7.108,7.108,0,0,0,2.067.272,5.292,5.292,0,0,1,2.293,1.036,2.29,2.29,0,0,1,.624.691,11.144,11.144,0,0,1,.467,1.084,3.93,3.93,0,0,0,3.784,2.243l.291-.083a.573.573,0,0,0,.153-.5c-.067-1.772-.927-3.4-1.56-5.059-.208-.545-1.851-4.613-1.936-4.749-.037-.06-4.283-1.191-4.416-1.208-.411-.052-1.18-.219-1.711-.333",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path265",
    d: "M338.374-195.619c-1.795,1.191-11.014,6.575-11.014,6.575s-7.8-4.036-9.5-5.048a8.578,8.578,0,0,1-3.707-4.557c-.931-2.117-1.267-2.231-2.272-2.889-.624-.411-2.028-1.565-2.08-1.6a2.025,2.025,0,0,0-.728-.272c-.135-.039-.7-.171-.832-.2-.781-.185-1.272-.257-2.053-.443a3.486,3.486,0,0,0-.729-.12l-.153.031-.067.281a1.756,1.756,0,0,0,.881,1.108,6.1,6.1,0,0,0,1.364.509c.288.084.451.109,1.031.284a1.359,1.359,0,0,1,.595.411,16.265,16.265,0,0,1,2.247,2.676,5.783,5.783,0,0,1-2.672-1.5c-.684-.689-1.323.2-.684,1.305.735,1.275,1.849,1.455,2.784,3.167s-.453,3.368,1.745,4.759a31.3,31.3,0,0,1,3.6,2.277c1.692,1.287,6.872,5.961,8.181,6.808,2.859,1.851,3,1.757,9.141-1.152,8.661-4.107,7.537-3.825,7.537-3.825L343.144-198a17.853,17.853,0,0,0-4.769,2.383",
    transform: "translate(0 533.387)",
    fill: "#91545d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M343.115-198.182a22.174,22.174,0,0,0-5.252,2.572c-5.5,3.3-10.469,6.358-10.469,6.358l-5.432-2.776a5.085,5.085,0,0,1-.5,3.256,3.8,3.8,0,0,1-2.985,2.033s1.984,1.74,4.379,3.7,3.408,2.36,4.2,2.485,1.748-.415,3.673-1.251,10.472-5.173,10.472-5.173l1.916-11.209",
    transform: "translate(0 533.387)",
    fill: "#1b1e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path267",
    d: "M311.36-198.88a6.975,6.975,0,0,1,1.593.916c.18.16.121-.4-.651-.988s-1.427-.536-1.6-.805l.661.877",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "M346.223-199.208l-3.091,1.023c-2.651,2.832-5.56,7.613-5.211,10.848a8.766,8.766,0,0,0,2.349,5.113,102.89,102.89,0,0,1,.595,10.685c-.151,3.563-.565,11.885-.565,11.885a11.442,11.442,0,0,0,4.311,1.244c.02-4.54-.841-21.037-1.619-24.9s-1.909-9.976,3.231-15.9",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path269",
    d: "M344.611-158.411a11.442,11.442,0,0,1-4.311-1.244s.415-8.322.565-11.885c.013-.327.02-.684.02-1.063,0-3.747-.615-9.622-.615-9.622a8.486,8.486,0,0,1-1.955-3.293,8.859,8.859,0,0,1-.395-1.82,5.2,5.2,0,0,1-.028-.544c0-3.208,2.733-7.626,5.239-10.3l1.343-.444a7.318,7.318,0,0,0-1.427,1.053,4.813,4.813,0,0,0-1.079,1.429,4.669,4.669,0,0,0-.391,1.761,5.1,5.1,0,0,0,.243,1.7,13.666,13.666,0,0,0-2.1,2.364,3.7,3.7,0,0,0-.384.748l-.059.212-.031.225a1.442,1.442,0,0,0,.061.441,12.435,12.435,0,0,0,.588,1.524c.437.988.937,1.941,1.425,2.9s1,1.9,1.505,2.853c-.429-.987-.883-1.963-1.34-2.935s-.9-1.951-1.333-2.931a12.656,12.656,0,0,1-.556-1.488,1.668,1.668,0,0,1,.391-1.379,14.393,14.393,0,0,1,2.1-2.387l.071-.068-.035-.093a5.176,5.176,0,0,1-.283-1.683,4.406,4.406,0,0,1,.311-1.685,5.084,5.084,0,0,1,.981-1.427,8.126,8.126,0,0,1,1.344-1.136l1.748-.579a15.209,15.209,0,0,0-3.909,10.334,27.546,27.546,0,0,0,.679,5.565c.769,3.816,1.617,19.973,1.619,24.734v.164",
    transform: "translate(0 533.387)",
    fill: "#1b1e67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M344.475-198.63h0",
    transform: "translate(0 533.387)",
    fill: "#9b66b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path271",
    d: "M342.827-181.419c-.5-.951-1.013-1.9-1.505-2.853s-.988-1.912-1.425-2.9a12.434,12.434,0,0,1-.588-1.524,1.442,1.442,0,0,1-.061-.441l.031-.225.059-.212a3.7,3.7,0,0,1,.384-.748,13.666,13.666,0,0,1,2.1-2.364,5.1,5.1,0,0,1-.243-1.7,4.669,4.669,0,0,1,.391-1.761,4.813,4.813,0,0,1,1.079-1.429,7.319,7.319,0,0,1,1.427-1.053h0a8.127,8.127,0,0,0-1.344,1.136,5.083,5.083,0,0,0-.981,1.427,4.406,4.406,0,0,0-.311,1.685,5.176,5.176,0,0,0,.283,1.683l.035.093-.071.068a14.391,14.391,0,0,0-2.1,2.387,1.668,1.668,0,0,0-.391,1.379,12.665,12.665,0,0,0,.556,1.488c.431.98.873,1.96,1.333,2.931s.911,1.948,1.34,2.935",
    transform: "translate(0 533.387)",
    fill: "#5e3575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M354.726-200.139a30.1,30.1,0,0,0-2.107,6.292c-1.069,4.344-2.139,8.309-1.461,12.044s5.243,22.865,5.243,22.865a22.421,22.421,0,0,0,10.021-2.913l-1.691-7.422,3.072,6.821a9.559,9.559,0,0,0,2.423-1.832c-2.612-7.57-5.6-11.1-6.241-13.954-.439-1.959.293-7.721-.239-12.71a29.571,29.571,0,0,0-2.192-8.128l-6.828-1.061",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path273",
    d: "M356.4-158.939s-.853-3.573-1.876-7.932c-1.344-5.727-2.983-12.812-3.367-14.933a13.786,13.786,0,0,1-.212-2.485,41.8,41.8,0,0,1,1.673-9.558,30.1,30.1,0,0,1,2.107-6.292l6.828,1.061a29.571,29.571,0,0,1,2.192,8.128,42.616,42.616,0,0,1,.2,4.469c0,2.279-.111,4.441-.112,6.068a11.068,11.068,0,0,0,.148,2.173c.639,2.851,3.629,6.384,6.241,13.954a9.559,9.559,0,0,1-2.423,1.832l-3.072-6.821,1.691,7.422a16.739,16.739,0,0,1-2.2,1.139q-.182.078-.364.152-.508.206-1.011.379c-.172.06-.344.117-.515.171a23.5,23.5,0,0,1-5.932,1.073m-1.811-40.315c.3.68.6,1.356.881,2.04a21.864,21.864,0,0,1,.776,2.063,1.438,1.438,0,0,1,.073.46l-.044.055-.084.112-.165.224-.657.9-1.3,1.812-.093.129.111.124c.333.372.655.764.953,1.164a4.518,4.518,0,0,1,.724,1.235l.011.121,0,.033-.036.069-.192.313-.411.643c-.273.429-.548.86-.812,1.3a30.36,30.36,0,0,0-1.439,2.707,12.273,12.273,0,0,0-.552,1.433,5.4,5.4,0,0,0-.268,1.507,8.712,8.712,0,0,1,1.027-2.839c.464-.9.993-1.765,1.543-2.617.268-.429.547-.853.827-1.277l.421-.637c.069-.112.139-.209.209-.335l.052-.1.039-.153-.016-.257a4.6,4.6,0,0,0-.78-1.4c-.283-.368-.577-.719-.887-1.061l1.172-1.681.628-.912.155-.231.077-.115a.769.769,0,0,0,.1-.18.815.815,0,0,0-.02-.348l-.079-.28a17.119,17.119,0,0,0-.893-2.053c-.335-.663-.676-1.321-1.045-1.965",
    transform: "translate(0 533.387)",
    fill: "#202372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M352.058-180.811a5.4,5.4,0,0,1,.268-1.507,12.278,12.278,0,0,1,.552-1.433,30.356,30.356,0,0,1,1.439-2.707c.264-.437.539-.868.812-1.3l.411-.643.192-.313.036-.069,0-.033-.011-.121a4.518,4.518,0,0,0-.724-1.235c-.3-.4-.62-.792-.953-1.164l-.111-.124.093-.129,1.3-1.812.657-.9.165-.224.084-.112.044-.055a1.438,1.438,0,0,0-.073-.46,21.864,21.864,0,0,0-.776-2.063c-.281-.684-.585-1.36-.881-2.04.369.644.711,1.3,1.045,1.965a17.116,17.116,0,0,1,.893,2.053l.079.28a.814.814,0,0,1,.02.348.769.769,0,0,1-.1.18l-.077.115-.155.231-.628.912-1.172,1.681c.309.343.6.693.887,1.061a4.6,4.6,0,0,1,.78,1.4l.016.257-.039.153-.052.1c-.071.125-.14.223-.209.335l-.421.637c-.28.424-.559.848-.827,1.277-.549.852-1.079,1.717-1.543,2.617a8.711,8.711,0,0,0-1.027,2.839",
    transform: "translate(0 533.387)",
    fill: "#5e3575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path275",
    d: "M352.569-201.188a1.091,1.091,0,0,1-.388.319c-.512.235-1.165-.44-1.772-.365-.5.061-.873.448-1.324.528a3.742,3.742,0,0,1-1.611-.357,7.591,7.591,0,0,1-2.684-1.648c-1.531-1.459-2.823-3.863-1.851-5.925a4.965,4.965,0,0,1-3.188-2.108,4.97,4.97,0,0,1-.709-3.756,6.4,6.4,0,0,0-.94,2.755,3.315,3.315,0,0,1-.739-2.7c.544-4.937,6.588-7.94,11.058-7.657,3.017.191,5.948,1.729,6.592,4.937a3.665,3.665,0,0,1,3.021,2.4,6.022,6.022,0,0,1-.04,3.995,17.9,17.9,0,0,1-1.824,3.633q-1.666,2.776-3.335,5.552a3.361,3.361,0,0,1-.268.4",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M354.187-205.1a1.54,1.54,0,0,0,1.141-.148,3.142,3.142,0,0,0,1.36-1.391,3.528,3.528,0,0,0,.249-2.505,1.955,1.955,0,0,0-1.155-1.207,1.464,1.464,0,0,0-1.347.036,1.31,1.31,0,0,0-.444.529,4.068,4.068,0,0,0-.26.737c-.061.215-.089.771-.4.787-.141.008-.223-.119-.275-.232a2.074,2.074,0,0,1-.133-.821c0-.163.151-1.449.12-1.465-1.659-.861-1.277-3.684-2.147-4.875a3.789,3.789,0,0,0-4.515-1.091,3.073,3.073,0,0,0-3.2-.331c-1.16.564-1.967,1.815-2.539,6.2-.583,4.469.076,7.488,1.075,8.48.687.681,2.552,1.095,4.133,1.065l.375,2.127s-2.856,3.289,1.845,3.156a7.647,7.647,0,0,0,6.193-3.995l-.955-5.764a1.3,1.3,0,0,0,.88.707",
    transform: "translate(0 533.387)",
    fill: "#91545d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path277",
    d: "M347.093-210.261a.753.753,0,0,0,.912.553.76.76,0,0,0,.519-.936.754.754,0,0,0-.913-.552.757.757,0,0,0-.517.935",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "M345.477-205.779a.575.575,0,0,0,.7.421.578.578,0,0,0,.4-.715.575.575,0,0,0-.7-.423.579.579,0,0,0-.4.716",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path279",
    d: "M341.667-213.133l1.592-.777a.85.85,0,0,0-1.157-.428.93.93,0,0,0-.435,1.205",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M343.169-210.659a.752.752,0,0,1-.976.428.757.757,0,0,1-.392-.995.753.753,0,0,1,.976-.429.76.76,0,0,1,.392,1",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path281",
    d: "M347.841-213.627l1.7.847a.91.91,0,0,0-.391-1.263,1,1,0,0,0-1.307.416",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "M342.55-208.539l2.36,1.012.545-4.409Z",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path283",
    d: "M345.849-201.335c2.276,0,5.025-.875,6.307-2.844-.347,1.831-2.787,3.123-4.077,3.432a7.132,7.132,0,0,1-2.071.312l-.159-.9",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M400.366-141.763l-7.448-18.865a1.656,1.656,0,0,0-1.024-.827l-.663-.18a.617.617,0,0,0-.52.043h0l-20.341,14.052,9.6,20.194L400.3-141.39h0a.292.292,0,0,0,.063-.372",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path285",
    d: "M379.971-127.347q2.588-1.686,5.149-3.416l5.1-3.483,5.064-3.539q2.524-1.78,5.017-3.605-2.59,1.686-5.149,3.415l-5.1,3.483-5.063,3.54q-2.526,1.78-5.019,3.606",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "M376.152-128.232l3.344.907c.433.117.679-.063.547-.4l-7.448-18.865a1.66,1.66,0,0,0-1.024-.827l-.663-.18c-.433-.117-.716.068-.629.413l4.932,18.114a1.383,1.383,0,0,0,.941.839",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path287",
    d: "M385.248-132.766a.3.3,0,0,1-.325-.157l-3.625-8.944c-.044-.113.036-.227.18-.255a.31.31,0,0,1,.341.155l3.625,8.945c.044.112-.037.225-.181.254l-.015,0",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M394.519-139.047a.306.306,0,0,1-.325-.157l-3.624-8.944c-.045-.113.036-.227.18-.255a.313.313,0,0,1,.341.155l3.624,8.944c.044.113-.036.227-.18.255l-.016,0",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path289",
    d: "M378.113-137.97a1.685,1.685,0,0,1-2.387-.592l-3.131-8.032a1.661,1.661,0,0,0-1.028-.823l-.659-.179a.65.65,0,0,0-.488.017l20.29-14.017v0a.59.59,0,0,1,.519-.043l.664.179a1.672,1.672,0,0,1,1.024.828l3.1,7.957a2.53,2.53,0,0,1-1.056,3.068L378.113-137.97",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    d: "M385.238-143.712l2.413-1.667.5,1.2-2.419,1.669-.5-1.2",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path291",
    d: "M383.777-156.8c-.984-1.7-2.485-4.425-3.1-4.387l.261-.851s.6-.157,1.616,1.313c.832,1.205,2.089,3.327,2.089,3.327l-.865.6",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M377.444-155.9a2.9,2.9,0,0,1-1.941-1.176,2.96,2.96,0,0,1,.02-1.931c.255-.395,1.387-2.039,1.853-1.988s1.328,2.34,1.081,3.3a4.886,4.886,0,0,1-1.013,1.793",
    transform: "translate(0 533.387)",
    fill: "#793c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path293",
    d: "M382.377-159.827a24.816,24.816,0,0,0-.116-3.456,22.256,22.256,0,0,0-.664-2.975c-.621-2.436-2.168-9.744-3.48-13.44l-5.971,4.784s3.952,7.724,4.372,9.025c.251.772-.455,1.869-.7,2.627a8.8,8.8,0,0,0-.331,2.225,13.466,13.466,0,0,1-.371,2.405l-.036.3a.5.5,0,0,0,.584.359,1.105,1.105,0,0,0,.619-.416,4.937,4.937,0,0,0,.815-1.64l.16-.2.2.111a2.488,2.488,0,0,1,.255.693,4.08,4.08,0,0,1-.188,1.847,1.6,1.6,0,0,1-1.241,1.315l.5.308a3.353,3.353,0,0,0,.6.224,1.523,1.523,0,0,0,1.119-.245c.455-.259.739-.781,1.232-.956a3.779,3.779,0,0,1,.412-.1,1.275,1.275,0,0,0,.783-.487c.153-.227.2-.524.4-.711a2.174,2.174,0,0,1,.365-.227,1.6,1.6,0,0,0,.684-1.376",
    transform: "translate(0 533.387)",
    fill: "#91545d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M376.272-159.177a4.539,4.539,0,0,0,.009,3.279c.4,1.065,1.431,3.285,1.431,3.285l.847-.587s-.355-.792-1.085-2.459a3.972,3.972,0,0,1-.4-2.892,1.761,1.761,0,0,1,.64-.872s-.031-.852-.387-.828c-.376.116-.636.283-1.056,1.073",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path295",
    d: "M370.387-177.641s-6.979-7.568-8.44-9.25-4.387-8.17-2.176-12.461c3.665-.015,4.863.5,7.881,4.273s7.568,9.713,9,11.745c1.083,1.535,1.509,3.049,2.249,5.827.644,2.427,1.056,4.355,1.056,4.355s-.519.865-2.944,1.6c-2.239.68-3.156.031-3.156.031l-3.472-6.119",
    transform: "translate(0 533.387)",
    fill: "#1c2072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "M266.865-128.589c-.347.554-1.269-.027-2.891-.68s-.877-7.909-.877-7.909a3.16,3.16,0,0,1,3.039,2.485c.435,2.436.729,6.1.729,6.1",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path297",
    d: "M253.5-141.49c-1.536-.045-4.953,1.68-5.508,2.868-.583,1.247-2.84,18.193-1.553,19.8,1.616,2.014,9.642,6.023,13.184,5.957,2.921-.053,5.736-2.7,6.191-3.472.747-1.269.065-18.75-.843-20.234-1.469-2.405-9.514-4.857-11.47-4.916",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    d: "M259.535-112.867l-.135,0a10.2,10.2,0,0,0-.432-3.925l-7.414.8-1.656-3.9-3.56.895a4.067,4.067,0,0,1-.239-1.208c-.036-.425-.052-.93-.052-1.494a112.865,112.865,0,0,1,1.577-15.369c2.939,1.608,10.352,5.118,11.624,5.118h.007l-.083,6.748-.012.824c0,1.121-1.071,11.211,1.885,11.211a1.445,1.445,0,0,0,.245-.021l.129-.02a9.9,9.9,0,0,0,4.377-3.112c-.493.8-3.283,3.4-6.177,3.449h-.085m3.888-25.122a28.515,28.515,0,0,0-9.926-3.5h0a28.518,28.518,0,0,1,9.925,3.5h0m-15.434-.629s0,0,0,0a1.683,1.683,0,0,1,.241-.364,1.683,1.683,0,0,0-.241.364,0,0,0,0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path299",
    d: "M265.8-116.317a.018.018,0,0,1,0-.007.018.018,0,0,0,0,.007",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "M265.8-116.325a.025.025,0,0,0,0-.007.025.025,0,0,1,0,.007",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path301",
    d: "M265.808-116.333a.011.011,0,0,0,0-.007s0,.005,0,.007",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    d: "M265.811-116.34a.006.006,0,0,0,0,0,.006.006,0,0,1,0,0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path303",
    d: "M265.815-116.345a.006.006,0,0,0,0,0v0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M265.817-116.349a.749.749,0,0,0,.051-.127.749.749,0,0,1-.051.127",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path305",
    d: "M265.868-116.477s0,0,0-.005,0,0,0,.005",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M265.871-116.483s0-.006,0-.007,0,0,0,.007",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path307",
    d: "M265.873-116.493s0,0,0-.006,0,0,0,.006",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M265.876-116.5a.01.01,0,0,0,0-.005s0,0,0,.005",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path309",
    d: "M265.879-116.511v0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M265.881-116.518v0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path311",
    d: "M265.931-116.738s0,0,0,0,0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M265.932-116.748c.011-.052.02-.109.028-.171.005-.031.009-.061.013-.095-.012.1-.027.187-.041.266",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path313",
    d: "M266.007-117.3l.02-.208.008-.108q-.012.169-.028.316",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M266.035-117.621a.036.036,0,0,0,0-.012.036.036,0,0,1,0,.012",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path315",
    d: "M265.368-134.863l-.032-.215c.011.069.021.141.032.215m-.239-1.279s0,0,0-.005,0,0,0,.005m0-.008s0-.005,0-.008,0,.005,0,.008m0-.011s0-.005,0-.007l0,.007m0-.009a.093.093,0,0,0,0-.009.093.093,0,0,1,0,.009m0-.011a2.1,2.1,0,0,0-.108-.311v0a0,0,0,0,1,0,0l0,0h0l-.012-.024a2.019,2.019,0,0,1,.124.345m-.124-.345a0,0,0,0,0,0,0,0,0,0,0,1,0,0m0-.005h0m0-.005h0m0-.005h0m-.013-.024h0m0,0h0m0,0h0a2.633,2.633,0,0,0-.275-.368h0a2.558,2.558,0,0,1,.275.368h0",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "M265.951-127.7c-.035-.732-.076-1.456-.12-2.155-.019-.28-.036-.556-.056-.827-.037-.543-.079-1.066-.121-1.561-.021-.248-.043-.49-.065-.723-.033-.351-.069-.682-.105-.994s-.072-.6-.111-.871l-.037-.259a5.16,5.16,0,0,0-.367-1.485l-.141-.205-.053-.068-.117-.14-.073-.081-.127-.131-.083-.083-.207-.187-.145-.121-.1-.08-.168-.132-.085-.064-.2-.143c-1.387.556-2.7,1.084-2.736,1.108a3.334,3.334,0,0,0-1.459,3.024l-.107,8.678-.012.824c0,1.151-1.128,11.758,2.131,11.189l.129-.02a9.837,9.837,0,0,0,4.391-3.135,1.83,1.83,0,0,0,.149-.579c.017-.112.032-.239.047-.377l.02-.216c.019-.227.036-.479.049-.756l.012-.282c.06-1.457.053-3.473,0-5.633-.012-.432-.025-.871-.041-1.311-.009-.293-.021-.588-.033-.883-.005-.146-.012-.294-.017-.441-.013-.295-.027-.59-.041-.881",
    transform: "translate(0 533.387)",
    fill: "#1f237d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path317",
    d: "M264.983-136.55h0l-.005-.009h0s0,0,0-.005h0a0,0,0,0,1,0,0,.1.1,0,0,0,.009.016m-.009-.016s0,0,0,0h0s0,0,0,0m0,0h0m0,0s0,0,0,0,0,0,0,0",
    transform: "translate(0 533.387)",
    fill: "#161c20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "M247.624-137.065h0a9.277,9.277,0,0,1,.365-1.552,9.418,9.418,0,0,0-.364,1.553",
    transform: "translate(0 533.387)",
    fill: "#696d6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path319",
    d: "M248.579-139.338h0a9.649,9.649,0,0,1,4.857-2.153h0a9.649,9.649,0,0,0-4.857,2.153",
    transform: "translate(0 533.387)",
    fill: "#606365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M264.995-136.526h0m0,0a0,0,0,0,0,0,0,0,0,0,0,1,0,0m0,0,0,0,0,0m0,0s0,0,0-.005,0,0,0,.005m0-.005,0-.008h0l0,.008",
    transform: "translate(0 533.387)",
    fill: "#101518"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path321",
    d: "M259.248-131.946c-1.272,0-8.685-3.51-11.624-5.118a9.42,9.42,0,0,1,.364-1.553,0,0,0,0,1,0,0,1.681,1.681,0,0,1,.241-.364,9.384,9.384,0,0,1,5.205-2.505h.06a28.515,28.515,0,0,1,9.926,3.5c-1.367.548-2.647,1.064-2.685,1.088a3.334,3.334,0,0,0-1.459,3.024l-.024,1.93h-.007",
    transform: "translate(0 533.387)",
    fill: "#3e244d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "M265.011-136.491v0m0-.005,0,0,0,0m0-.005c-.009-.02-.02-.04-.029-.057l.009.017h0s0,0,0,.005h0l0,0h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0h0l.012.024m-.029-.057s0,0,0-.005,0,0,0,.005m0-.005s0,0,0,0,0,0,0,0h0a0,0,0,0,0,0,0m0-.005s0,0,0,0h0s0,0,0,0h0m0,0-.141-.205-.053-.068-.08-.095a2.634,2.634,0,0,1,.275.368",
    transform: "translate(0 533.387)",
    fill: "#3e244d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323",
    d: "M259.255-131.946l.024-1.93a3.334,3.334,0,0,1,1.459-3.024c.039-.024,1.319-.54,2.685-1.088a6.236,6.236,0,0,1,1.271,1.047l.08.095.053.068.141.205h0s0,0,0,0h0s0,0,0,0h0s0,0,0,.005h0c.009.017.02.037.029.057h0l0,0a0,0,0,0,0,0,0v0a4.279,4.279,0,0,1,.236.885v0a52.305,52.305,0,0,1-5.88,3.64.326.326,0,0,1-.111.016",
    transform: "translate(0 533.387)",
    fill: "#522f66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M266.547-124.247c-.092-.048-1.428-1.068-1.583-1.148-.275-.143-4.285,2.522-4.659,2.977-.26.316.1,5.249.252,5.6.056.127,1.528,1.022,1.583,1.148.153.353,4.388-2.354,4.657-3.016s.151-5.353-.251-5.562",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325",
    d: "M262.14-115.669c-.055-.125-1.527-1.021-1.583-1.148a33.027,33.027,0,0,1-.344-4.631,2.677,2.677,0,0,1,.092-.971v0h0l1.583,1.148h0a2.687,2.687,0,0,0-.092.972,33,33,0,0,0,.344,4.63",
    transform: "translate(0 533.387)",
    fill: "#8b47a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "M261.888-121.27c-.26.317.1,5.249.252,5.6s4.388-2.354,4.657-3.016.151-5.353-.251-5.562c-.275-.142-4.287,2.522-4.659,2.977",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path327",
    d: "M261.888-121.27l-1.583-1.148h0a.341.341,0,0,1,.18-.043,2.857,2.857,0,0,1,1.384.664,1.328,1.328,0,0,1,.236.325,1.9,1.9,0,0,0-.217.2",
    transform: "translate(0 533.387)",
    fill: "#502e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M262.211-115.637c-.037,0-.061-.01-.071-.032a33,33,0,0,1-.344-4.63,2.687,2.687,0,0,1,.092-.972h0a1.9,1.9,0,0,1,.217-.2c.331.575.747,1.605,1.537,1.808a1.066,1.066,0,0,0,.263.032,3.307,3.307,0,0,0,2.431-1.914,7.645,7.645,0,0,0,.413-2.125,21.108,21.108,0,0,1,.192,3.062,7.961,7.961,0,0,1-.144,1.924c-.252.621-4,3.048-4.587,3.048",
    transform: "translate(0 533.387)",
    fill: "#784197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329",
    d: "M261.888-121.27h0a1.9,1.9,0,0,1,.217-.2h0a1.9,1.9,0,0,0-.217.2",
    transform: "translate(0 533.387)",
    fill: "#422752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "M260.305-122.418c.3-.191,1.183.29,1.564.621s.785,1.881,1.773,2.133,2.393-1.047,2.693-1.883.66-2.6.185-3.228a1.624,1.624,0,0,0-2.012-.606c-.7.373-4.113,2.192-4.2,2.962",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331",
    d: "M263.905-119.632a1.066,1.066,0,0,1-.263-.032c-.791-.2-1.207-1.233-1.537-1.808h0a1.328,1.328,0,0,0-.236-.325,2.857,2.857,0,0,0-1.384-.664.341.341,0,0,0-.18.043c.091-.771,3.5-2.589,4.2-2.962a1.3,1.3,0,0,1,.617-.154,1.816,1.816,0,0,1,1.395.76,1.711,1.711,0,0,1,.229,1,7.545,7.545,0,0,1-.415,2.232,3.307,3.307,0,0,1-2.431,1.914",
    transform: "translate(0 533.387)",
    fill: "#934ead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M264.757-121.7a.735.735,0,0,0-.349.68.3.3,0,0,0,.451.264.721.721,0,0,0,.349-.68c-.029-.264-.231-.383-.451-.264",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path333",
    d: "M259.256-131.946a6.39,6.39,0,0,1,3.04-3.448c2.479-1.411,2.548-.96,3.328.425.7,1.248.953,5.881.984,6.325s.561.364.5-2.469-.44-5.548-3.073-7.245c-3.543-2.287-9.041-3.8-11.64-3.252s-4.939,1.833-4.772,4.544c0,0,3.335,4.519,11.633,5.12",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "M238.81-114.056l11.638-.392-.629,16.3a5.54,5.54,0,0,1,1.475.72,24.126,24.126,0,0,1,4.625,4.744,63.474,63.474,0,0,0,5.925,6.455A17.572,17.572,0,0,1,264-85.118c.461.273,2.119,1.653,2.569,1.988.493.365-.257,1.677-.748,2.8a6.358,6.358,0,0,0-.569,3.194,6.739,6.739,0,0,1-.767,3.195,8.085,8.085,0,0,1-2.435,2.776c-.673.583-2.623,1.195-2.812-.2-.2-1.489.528-2.619.892-4.758.413-2.433-.336-4.72-1.715-5.654s-2.053-1.4-3.509-2.348c-3.873-2.521-4.824-3.243-8.214-5.449-1.809-1.179-2.672-1.869-4.337-3.037a6.464,6.464,0,0,1-2.887-5.14l-.66-16.311",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path335",
    d: "M264-85.118c.461.273,2.119,1.653,2.569,1.988.493.365-.257,1.677-.748,2.8a6.358,6.358,0,0,0-.569,3.194,6.739,6.739,0,0,1-.767,3.195,8.085,8.085,0,0,1-2.435,2.776c-.673.583-2.623,1.195-2.812-.2-.2-1.489.528-2.619.892-4.758.413-2.433-.336-4.72-1.715-5.654s-2.053-1.4-3.509-2.348c-3.527-2.3-4.632-3.1-7.361-4.892,2.523-.924,4.933-4.681,4.952-7.451a31.763,31.763,0,0,1,3.42,3.781,63.472,63.472,0,0,0,5.925,6.455A17.576,17.576,0,0,1,264-85.118",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M251.668-86.258c2.171-.884,3.983-3.635,4.564-6.052l-.313-.372q-.228-.273-.452-.545c-.516,2.512-2.429,5.48-4.723,6.349.3.2.6.406.924.62m3.1-7.821q-.376-.452-.781-.905c-.383,2.688-2.52,6.106-5.065,6.879l.932.624c2.421-.81,4.451-3.992,4.915-6.6",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path337",
    d: "M259.839-70.574a1.3,1.3,0,0,0,1.2.69,6.214,6.214,0,0,0,3.571-2.8,6.066,6.066,0,0,0,1.3-3.784,7.2,7.2,0,0,1,.46-3.168,9.667,9.667,0,0,0,1.057-2.579c-.019-.409-.968-1.176-.968-1.176l-6.625,12.818",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "M261.92-86.2a.385.385,0,0,1,.459-.1c.3.168,1.085.752,1.6,1a13.247,13.247,0,0,1,2.78,2.216c.4.5-.533,2.238-.883,3.216a9.553,9.553,0,0,0-.487,3.161,7.14,7.14,0,0,1-1.52,4.088c-1.1,1.307-2.717,2.442-3.571,2.285-1.055-.192-1.784-.719-1.021-3.4.144-.508.457-2.188.561-2.856a10.024,10.024,0,0,0-.063-2.085,2.988,2.988,0,0,0-.467-1.526,8.172,8.172,0,0,0-.588-.681l-.137-.219c-.049-.2.188-.457.289-.615a7.514,7.514,0,0,1,.5-.693,7.923,7.923,0,0,1,.753-.805c.243-.227.515-.521.883-.478a.822.822,0,0,1,.413.209,3.441,3.441,0,0,0,.363.3l.159.049.153-.259a6.653,6.653,0,0,0-.157-1.037c-.032-.185.241-.657.253-.847a4.881,4.881,0,0,0,.073-.509c-.013-.215-.2-.279-.347-.412",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path339",
    d: "M265.385-76.709a13.094,13.094,0,0,1,.1-1.468v0s-.945,2.745-2.305,3.157a.989.989,0,0,1-1.241-.562,6.521,6.521,0,0,0-2.533,1.3h0c-.049.234-.093.428-.127.545-.763,2.682-.033,3.209,1.021,3.4.853.156,2.185-.531,3.589-2.229a7.36,7.36,0,0,0,1.5-4.144",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M261.632-76.119c-.547,1.605.093,1.272.419.972s.816-2.81.92-4.855c.108-2.132.025-4.145.069-4.933.016-.294.015-.628.005-.932-.277-.184-.527-.356-.667-.435a.541.541,0,0,0-.535.075l.371.3a1.871,1.871,0,0,1-.072.637,2.092,2.092,0,0,0-.2.856A6.649,6.649,0,0,1,262.1-83.4a18.525,18.525,0,0,1-.465,7.28",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path341",
    d: "M261.955-75.378l.037-.1-.144-.153a3.748,3.748,0,0,0-2.656,1.509l.036.215.208-.047a3.473,3.473,0,0,1,2.4-1.368l.117-.057",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M262.271-76.922l.039-.1-.14-.157a3.735,3.735,0,0,0-2.687,1.447l.031.215.209-.04a3.457,3.457,0,0,1,2.429-1.312l.119-.055",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path343",
    d: "M262.443-78.453l.037-.1-.145-.155a3.741,3.741,0,0,0-2.656,1.511l.036.213.209-.045a3.466,3.466,0,0,1,2.4-1.369l.119-.057",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M262.457-79.7l.041-.1-.137-.16a3.73,3.73,0,0,0-2.712,1.395l.027.215.211-.036a3.456,3.456,0,0,1,2.451-1.265l.12-.051",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path345",
    d: "M262.46-81.131l.04-.093-.136-.163a3.82,3.82,0,0,0-2.893,1.595l.028.215.211-.037a3.543,3.543,0,0,1,2.628-1.464l.123-.052",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "M237.739-98.072s0-4.6.051-10.876c.044-5.991.235-6.963.451-8.011l11.657-2.931,2.121,4.992.128,17.335c-3.555,2.055-11.408,1.7-14.408-.509",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path347",
    d: "M244.67-96.839c-.108,0-.216,0-.325-.007l-.509-8.669a10.535,10.535,0,0,1-3.876-5.552,12.959,12.959,0,0,0,4.928,4.927s0,4.932.177,9.292l-.2.007-.192,0",
    transform: "translate(0 533.387)",
    fill: "#1a1c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M252.152-98.444a25.863,25.863,0,0,1-7.29,1.6c-3.349.079-7.249-1.937-7.249-1.937l-.091,1.769a11.374,11.374,0,0,0,7.424,2.086c4.8-.155,7.2-1.834,7.2-1.834l.007-1.687",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path349",
    d: "M244.475-94.916a12.361,12.361,0,0,1-5.8-1.353,7,7,0,0,1-1.156-.74l.091-1.769a18.419,18.419,0,0,0,7.057,1.94l.192,0,.2-.007c.005.11.009.221.015.331l-.112-.061h0L245-94.926l-.056,0c-.159,0-.316.007-.471.007",
    transform: "translate(0 533.387)",
    fill: "#212468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M241.55-65.836c1.053-1.119,2.421-1.268,4.357-2.356,2.2-1.238,3.537-3.308,3.391-5.006s-.208-2.536-.393-4.3c-.491-4.7-.529-5.926-.957-10.043-.328-3.15-.491-3.791-.712-8.761-.124-2.793-.48-5.71-.8-10.857,0,0-1.405-.1-3.948-2.653a19.108,19.108,0,0,1-2.753-4.78l18.545-.9a37,37,0,0,1,.3,7.2c-.1,3.7-.807,12.488-1.805,16.564a22.818,22.818,0,0,1-.4,9.521,64.987,64.987,0,0,0-1.315,8.871,17.831,17.831,0,0,1,.507,2.429c.081.544.051,2.75.075,3.324.027.627-1.5.875-2.709,1.21a6.5,6.5,0,0,0-2.908,1.606,6.912,6.912,0,0,1-3.035,1.449,8.286,8.286,0,0,1-3.776-.149c-.9-.16-2.64-1.315-1.653-2.363",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path351",
    d: "M255.556-70.913c.081.544.051,2.75.075,3.324.027.627-1.5.875-2.709,1.21a6.5,6.5,0,0,0-2.908,1.606,6.912,6.912,0,0,1-3.035,1.449,8.286,8.286,0,0,1-3.776-.149c-.9-.16-2.64-1.315-1.653-2.363,1.053-1.119,2.421-1.268,4.357-2.356a5.565,5.565,0,0,0,3.008-4.911c-.079-1.7-.141-2.744-.271-4.793-.272-4.3-.259-5.285-.592-8.609,2.361,1.411,6.9.907,9.116-.864a32.477,32.477,0,0,1-.8,5.156,58.378,58.378,0,0,0-1.149,8.729c.152.616.129,1.132.341,2.571",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M248.435-81.454c2.1,1.156,5.54.826,7.836-.269l.093-.489c.047-.238.095-.473.143-.711-2.331,1.208-5.969,1.6-8.137.335,0,0,.044.748.065,1.134Zm8.3-2.576c.077-.394.151-.8.216-1.205-2.383,1.426-6.481,1.964-8.737.436.037.4.053.73.087,1.1,2.2,1.4,6.061.98,8.434-.33",
    transform: "translate(0 533.387)",
    fill: "#1a1d5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path353",
    d: "M241.009-65.21a1.373,1.373,0,0,0,.235,1.448,6.563,6.563,0,0,0,4.681,1.071,6.423,6.423,0,0,0,3.977-1.449,7.609,7.609,0,0,1,2.912-1.732,10.207,10.207,0,0,0,2.823-.848c.324-.287.323-1.58.323-1.58l-14.95,3.091",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M255.244-73.907a.407.407,0,0,1,.387.311c.06.357.1,1.393.24,1.979a14.022,14.022,0,0,1,.029,3.761c-.149.661-2.2,1.054-3.232,1.416a10.131,10.131,0,0,0-2.923,1.705,7.545,7.545,0,0,1-4.373,1.473c-1.8-.031-3.817-.608-4.256-1.412-.544-1-.6-1.947,2.116-3.107.513-.22,2.1-1.081,2.721-1.44a10.706,10.706,0,0,0,1.672-1.44,3.177,3.177,0,0,0,.945-1.4,8.482,8.482,0,0,0,.168-.936l.088-.26c.131-.171.5-.151.7-.171a8.577,8.577,0,0,1,.905-.048,8.293,8.293,0,0,1,1.164.083c.348.049.771.076.98.409a.874.874,0,0,1,.1.477,3.622,3.622,0,0,0,0,.5l.065.164.315-.046a6.948,6.948,0,0,0,.748-.821c.132-.149.7-.239.865-.355a4.753,4.753,0,0,0,.467-.28c.168-.153.095-.352.108-.557",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path355",
    d: "M249.746-64.736a14.111,14.111,0,0,1,1.272-.9v0s-2.887,1.051-4.131.208a1.047,1.047,0,0,1-.364-1.4,6.9,6.9,0,0,0-2.759-1.215h0c-.225.116-.413.208-.532.258-2.715,1.16-2.66,2.111-2.116,3.107.439.8,1.891,1.443,4.223,1.464a7.773,7.773,0,0,0,4.407-1.525",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M246.762-67.428c-1.684.62-.984.924-.52.992s2.853-1.2,4.6-2.479c1.825-1.331,3.424-2.74,4.1-3.228.253-.182.527-.406.769-.616-.032-.351-.057-.671-.085-.839-.051-.3-.419-.39-.419-.39l0,.5a2.033,2.033,0,0,1-.572.367,2.211,2.211,0,0,0-.839.4,6.947,6.947,0,0,1-.748.821,19.6,19.6,0,0,1-6.294,4.467",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path357",
    d: "M246.367-66.669l.105-.034.031-.221a3.966,3.966,0,0,0-3.011-1.179l-.151.172.176.141a3.672,3.672,0,0,1,2.724,1.063l.125.058",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M247.847-67.438l.105-.032.036-.22a3.951,3.951,0,0,0-2.979-1.245l-.156.168.173.145a3.66,3.66,0,0,1,2.7,1.122l.124.061",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path359",
    d: "M249.219-68.315l.105-.035.031-.221a3.963,3.963,0,0,0-3.011-1.179l-.152.172.177.142a3.671,3.671,0,0,1,2.724,1.061l.125.06",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M250.252-69.133l.107-.031.041-.22a3.955,3.955,0,0,0-2.953-1.3l-.159.166.169.149A3.652,3.652,0,0,1,250.13-69.2l.123.064",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path361",
    d: "M251.432-70.086l.105-.029.043-.22a4.039,4.039,0,0,0-3.239-1.316l-.157.167.171.148a3.746,3.746,0,0,1,2.953,1.185l.124.065",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "M245.154-95.019c-.269-4.669-.267-11.121-.267-11.121s-5.492-2.836-6-8.485l20.077-2.169c.773,2.626.353,3.636.309,6.477-.048,3.036-.552,10.985-.883,15.583-3.583,1.688-10.7,2.257-13.241-.285",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path363",
    d: "M256.875-95.688c.012-2.1.029-6.688-.005-10.566l-.005-.543c0-.333-.005-.653-.008-.961.061-.005.124-.01.185-.017l-.039-.336-.151.016c-.041-3.994-.123-5.839-.841-7.694l.316-.121c.813,2.1.831,4.154.875,9.111l.005.543c.035,3.822.017,8.33.007,10.477l-.339.092",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M256.479-107.744c-1.792,0-3.324-1.012-3.54-2.421l-.688-4.488.333-.052.688,4.488c.188,1.227,1.607,2.136,3.219,2.136.12,0,.24-.006.361-.015,0,.11,0,.222,0,.337-.128.011-.253.015-.377.015",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path365",
    d: "M256.856-107.759c0-.115,0-.227,0-.337l.151-.016.039.336c-.061.007-.124.012-.185.017",
    transform: "translate(0 533.387)",
    fill: "#6d3c89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "M258.647-96.223a25.856,25.856,0,0,1-7.337,1.379,14.685,14.685,0,0,1-6.342-1.733L245-94.839s1.525,1.92,6.332,1.915,7.253-1.612,7.253-1.612l.059-1.687",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path367",
    d: "M251.312-92.924c-4.788,0-6.309-1.915-6.309-1.915v-.087l-.035-1.652a14.685,14.685,0,0,0,6.342,1.733c.031,0,.06,0,.089,0a26.049,26.049,0,0,0,7.248-1.38l-.059,1.687s-2.447,1.605-7.253,1.612h-.023",
    transform: "translate(0 533.387)",
    fill: "#1a1d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M258.974-126.245c-.02-2.05.215-5.6.291-6.479.153-1.764.109-3.343-2.1-4.405l-5.353-1.948s-3.339-.16-5.5-.091a19.665,19.665,0,0,0-4.276.812c-1.221.971-3.451,3.4-3.92,8.353-.068.721-.1,2.055-.333,5.933-.2,3.312-.568,6.932.307,7.593,5.635,3.216,14.681,4.433,20.961.741,1.819-1.569-.037-6.262-.077-10.51",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path369",
    d: "M239.634-145.262a7.384,7.384,0,0,1,1.82-2.585c.124-.12.252-.245.373-.376-.139-.273-.251-.463-.251-.463-2.005-3.032-1.3-6.24.264-7.669,1.408-1.285,2.391-1.761,5.047-1.6a6.806,6.806,0,0,1,3.253-.871,9.189,9.189,0,0,1,4.719,1.169,6.993,6.993,0,0,1,3.015,3.765,37.793,37.793,0,0,1,.607,4.745,7.142,7.142,0,0,0,.9,2.185,5.286,5.286,0,0,1,.479,3.965,2.65,2.65,0,0,1-2.483,1.88,1.516,1.516,0,0,0,.293-1.315,3.865,3.865,0,0,1-2.4,2.529,5.206,5.206,0,0,1-3.547-.06.733.733,0,0,0,.3-.511c0-.043-1.651-.3-1.812-.327q-.452-.072-.9-.161a4.572,4.572,0,0,1-.851.793,3.6,3.6,0,0,1-1.228.593,5.34,5.34,0,0,1-3.644-.316,2.841,2.841,0,0,1-1.507-1.419,1.888,1.888,0,0,0-.155,1.072,3.042,3.042,0,0,1-2.357-1.915,4.285,4.285,0,0,1,.068-3.111",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "M241.526-148.79c-.1.864-.253,1.2-.367,2.6a5.4,5.4,0,0,0,.832,3.573,5.252,5.252,0,0,0,3.723,1.948l.356.032-.059,2.035c-.319,1.36.017,1.945.9,3.1a14.326,14.326,0,0,0,5.785-2.772l.648-6.461s.363.752,1.624.445a2.162,2.162,0,0,0,1.251-2.612,1.32,1.32,0,0,0-1.444-.972c-.972.095-1.033,1.359-1.675,1.161-.6-.185-.609-1.467-.7-2.044-.5-3.244-2.844-5.323-5.545-5.083-2.516-1.055-4.223.152-4.869,2a10.177,10.177,0,0,0-.465,3.044",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path371",
    d: "M243.3-154.907c-1.172,3.556,2.277,5.249,2.277,5.249s-.616-2.185.2-3.156a3.629,3.629,0,0,0,2.424,3.444,4.32,4.32,0,0,1-.053-2.808s.487,2.683,4.54,3.317c0,0,.475-4.391-2.969-6.139a6.875,6.875,0,0,0-6.415.092",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M247.735-148.142a.728.728,0,0,0,.6.836.732.732,0,0,0,.815-.636.73.73,0,0,0-.6-.837.735.735,0,0,0-.816.637",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path373",
    d: "M249.856-149.342l-1.289-.668a.726.726,0,0,1,.98-.311.725.725,0,0,1,.309.979",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "M243.925-150.954l-1.413.419a.738.738,0,0,1,.5-.917.738.738,0,0,1,.916.5",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path375",
    d: "M247.959-145.232l-2.2.484a1.106,1.106,0,0,0,1.319.895,1.18,1.18,0,0,0,.881-1.379",
    transform: "translate(0 533.387)",
    fill: "#a85361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M246.461-143.9a1.491,1.491,0,0,1,1.517-1.075,1.169,1.169,0,0,1-.9,1.123,1.063,1.063,0,0,1-.617-.048",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path377",
    d: "M242.469-148.92a.728.728,0,0,0,.6.836.732.732,0,0,0,.815-.636.728.728,0,0,0-.6-.836.732.732,0,0,0-.815.636",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M245.93-149.154l-.379,3.253-1.893-.6Z",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path379",
    d: "M246.071-140.644a10.385,10.385,0,0,0,4.409-.884A4.738,4.738,0,0,0,252.215-143a4.129,4.129,0,0,1-1.067,1.761c-1.693,1.5-5.1,1.4-5.1,1.4l.024-.8",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M246.887-157.956s8.66,1.073,7.312,10.336a1.285,1.285,0,0,1,.579-.248s.863-3.911-.871-6.526-4.532-4.1-7.02-3.561",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path381",
    d: "M258.726-136.215c1.54.615,2.352.579,3.313,4.2,1.021,3.853,1.029,4.428,1.923,12.037.651,5.537-1.672,5.367-3.507,4.741l-3.441-9.168s-.349-1.333-.844-3.627c-.788-3.65.8-7.6,2.556-8.184",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "M257.012-124.488a37.807,37.807,0,0,1,5.435,4.769,6.5,6.5,0,0,0-2.205-3.2,27.6,27.6,0,0,0-3.521-2.813l.292,1.24",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path383",
    d: "M255.039-129.849c-.431-2.531,1.209-6.55,2.928-7.044,2.484.9,3.447,1.6,4.209,4.753.8,3.313,1.444,8.632,1.444,8.632a11.546,11.546,0,0,1-6.962.928l-.463-2.3-1.156-4.969",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M255.526-137.763a13.862,13.862,0,0,0-3.2,7.95c-.557,5.953,6.507,11.917,6.507,11.917a11.979,11.979,0,0,0,.127-2.551s-4.563-4.821-4.144-8.613c.524-4.737,2.859-7.679,3.295-7.835l-2.584-.869",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path385",
    d: "M260.455-115.237a8.153,8.153,0,0,1-3.24-2.028,23.749,23.749,0,0,1-3.036-3.794,21.134,21.134,0,0,0-1.551-1.728c-.271-.274-.8-.848-1.019-1.115a5.905,5.905,0,0,1-1-1.873,4.014,4.014,0,0,1-.129-2.069c.044-.2.117-.392.155-.592.051-.277-.013-.565.032-.844.1-.595.391-.568.473-1.055a2.577,2.577,0,0,1,.469-1.409c.232-.208.575-.207,1.08-.245-.068.3-.149.713-.231,1.133a2.693,2.693,0,0,0,.517,1.577c.7,1,1.319,1.53,1.417,1.336s-.156-.813-.021-1.8c.129-.941.42-1.331.724-1.395.487-.1.463.417.633,1.215a9.8,9.8,0,0,1,.587,2.876c0,1.22-.055,1.152.411,1.895a14.031,14.031,0,0,0,1.455,1.517c1.853,1.332,3.925,2.613,4.7,4.883s.267,3.937-2.429,3.514",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "M246.915-135.5l2.469,2.1a11.578,11.578,0,0,0,2.963-2.373,10.589,10.589,0,0,0,1.555-2.78l-.967-2.067a4.522,4.522,0,0,1-1.533,2.8,27.931,27.931,0,0,1-4.487,2.325",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path387",
    d: "M246.915-135.5l-2.723.692a28.277,28.277,0,0,1,.545-2.929,8.983,8.983,0,0,1,1.332-2.451l.019,1.409a8.4,8.4,0,0,0,.827,3.279",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    d: "M241.921-138.5c-2.952.284-4.184,1.08-5.853,3.751-1.219,1.949-4.441,7.435-4.441,7.435s-.563,2.918,3.043,2.242,5.009-2.005,5.009-2.005l2.243-11.422",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path389",
    d: "M233.3-125.246a15.9,15.9,0,0,0,3.417-1.87c.529-.535.492-3.373,1.875-3.5l.171,4.241-3.667,2.731-1.8-1.6",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "M241.977-138.65c-1.911.244-3.469.436-4.812,2.115s-4.052,6.237-4.052,6.237,1.535,3.283,6.545,2.947l2.319-11.3",
    transform: "translate(0 533.387)",
    fill: "#d9dad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path391",
    d: "M244.8-139.011s-1.384.367-2.984,4.288A16.654,16.654,0,0,0,240.8-129.8c-.073.9-1.2,1.814-1.113,2.943-.223-1.079-.853-1.992-.849-3.027.012-2.613.6-7.033,3.144-8.764a8.119,8.119,0,0,1,2.825-.361",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "M231.626-127.317a15.972,15.972,0,0,0-3.02,5.827c-.351,2.148.141,4.488,2.988,3.819a11.713,11.713,0,0,0,2.869-.992,17.212,17.212,0,0,0,3.679-2.417,19.809,19.809,0,0,0,3.568-4.012,4.716,4.716,0,0,0,.833-2.556,5.329,5.329,0,0,0-.2-1.061,4.137,4.137,0,0,1-.023-.823,8.494,8.494,0,0,0-.116-2.105,5.467,5.467,0,0,0-.313-.934,1.657,1.657,0,0,0-.256-.416l-.3-.284a7.436,7.436,0,0,0-.18.781,13.515,13.515,0,0,1-.375,1.629,3.919,3.919,0,0,1-.749,1.328,1.088,1.088,0,0,1-.481.369c-.364.12-.628.055-.639-.031a16.113,16.113,0,0,1-.029-2.057c-.432-.021-.943.844-1.068,1.983a11.4,11.4,0,0,1-.272,1.717c-.2.781-1.237,1.7-2.879,2.477-1.387-.1-1.887-1.706-3.043-2.242",
    transform: "translate(0 533.387)",
    fill: "#f9a796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path393",
    d: "M234.906-125.189a19.619,19.619,0,0,0-3.748,1.7,7.8,7.8,0,0,1,2.557-1.937,4.455,4.455,0,0,1,1.191.241",
    transform: "translate(0 533.387)",
    fill: "#f2846b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "M199.052-120.98a9.9,9.9,0,0,0-.992.376.974.974,0,0,1-1.132-.231c-.264-.409.044-.936.343-1.321,1.6-2.076,3.248-4.336,3.421-6.955a4.1,4.1,0,0,0-1.405,1.543,4.587,4.587,0,0,1-1.024,1.266,1.588,1.588,0,0,1-1.533.289l-.16-.125.023-.257c.607-1.627,1.429-3.2,2.139-4.783a11.7,11.7,0,0,1,.824-1.615c.708-1.095,2.1-2.309,2.385-3.583.081-.363.252-1.191.252-1.191s1.56.088,2.215.216a16,16,0,0,1,2.976.885c.305.124.74.165.823.547a1.363,1.363,0,0,1-.064.631c-.445,1.683-.876,3.369-1.189,5.081-.456,2.493-.765,4.812-2.291,6.886a3.559,3.559,0,0,1-1.983,1.423,3.865,3.865,0,0,0-.907.234,5.978,5.978,0,0,0-.584.419,1.809,1.809,0,0,1-1.091.309,7.551,7.551,0,0,0-.863-.072l-.183.027",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path395",
    d: "M204.07-172.185c2.777.655,4.321,2.861,5.223,7.062s2.088,10.77,2.611,13.244c.669,3.168.284,3.419-.428,6.409s-2.779,9.658-2.779,9.658-4.916.36-6.889-2.368c0-.213,2.405-11.489,2.405-11.489l-2.6-12.25,2.461-10.266",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M207.415-77.29c-.7-1.47-.944-4.177-.895-9.1l-7.257,2.467s1.537,7.184,1.641,8.781c.265,4.09,6.51-2.145,6.51-2.145",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path397",
    d: "M209.259-74.86c.087-.16.321-.505.3-.591A3.45,3.45,0,0,0,208.519-77a8.851,8.851,0,0,1-1.091-1.432c-.187-.259-.308-.564-.6-.681a5.43,5.43,0,0,0-3.087.609c-1.6.84-2.089,1.852-2,2.949.071.836.239,1.366-.161,1.249s-.68-.835-.681-.838a5.5,5.5,0,0,1-.049.815,11.056,11.056,0,0,1-.043,2.08,5.781,5.781,0,0,1-1.879,3.828,17.357,17.357,0,0,1-3.239,1.5,1.947,1.947,0,0,0-.752.561A1.522,1.522,0,0,0,195-64.691a2.875,2.875,0,0,0,1.292,1.069,6.047,6.047,0,0,0,1.953.067,17.018,17.018,0,0,0,4.031-.61,6.272,6.272,0,0,0,2.305-1.063A5.517,5.517,0,0,0,206.1-67.4c.351-.821.585-1.685.881-2.528a27.414,27.414,0,0,1,1.48-3.345,15.028,15.028,0,0,0,.769-1.531l.027-.057",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    d: "M207.4-67.958a6.509,6.509,0,0,1-.285,1.125,3.279,3.279,0,0,1-1.059,1.54,7.4,7.4,0,0,1-1.1.708,12.1,12.1,0,0,1-3.432,1.077,15.065,15.065,0,0,1-2.728.215,8.277,8.277,0,0,0,3.048-1.745A5.384,5.384,0,0,0,203-66.4c.075-.125.145-.255.212-.385a22.6,22.6,0,0,0,1.236-3.838,8.892,8.892,0,0,1,.74-1.833,6.923,6.923,0,0,1,1.295-1.509c2.008-1.946,3.463-1.157,3.475-1.151.257.135.195.919.043,1.279a7.836,7.836,0,0,1-.905,1.519c-.236.328-.453.668-.665,1.01a5.634,5.634,0,0,0-.769,1.631,11.292,11.292,0,0,0-.187,1.235c-.02.164-.044.327-.071.488",
    transform: "translate(0 533.387)",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path399",
    d: "M194.742-64.533c-.005.327.968.9,1.607,1.043a6.972,6.972,0,0,0,5.073-.594,5.4,5.4,0,0,0,1.821-1.827c1.085-1.706,1.161-3.658,1.776-5.531a5.215,5.215,0,0,1,1.6-2.418c2.032-1.688,3.339-1.259,3.339-1.259a1.253,1.253,0,0,0-.725-.572,4.67,4.67,0,0,0-4.045,2.293,8.374,8.374,0,0,0-1.124,3.409,12.648,12.648,0,0,1-.491,1.738,7.088,7.088,0,0,1-.848,1.926,5.5,5.5,0,0,1-2.755,2.093,7.023,7.023,0,0,1-3.473.26,2.786,2.786,0,0,1-1.455-.76,1.657,1.657,0,0,1-.273-.514c-.023.154-.023.556-.024.712",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M204.6-140.1a48.394,48.394,0,0,1,.915,15.11c-.275,3.864-.869,20.3-.869,20.3a46.689,46.689,0,0,1,1.784,10.744c.224,6.067.291,12.016.291,12.016a6.864,6.864,0,0,1-2.756,1.856,8.047,8.047,0,0,1-4.025.413s-3.021-9-4.837-14.475a46.152,46.152,0,0,1-2.845-12.554c-.865-7.834-2.275-18.842-2.275-18.842L185.643-140.1H204.6",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path401",
    d: "M201.178-79.569a7.612,7.612,0,0,1-1.241-.092S198-85.422,196.3-90.53c-.427-1.276-.837-2.51-1.2-3.605-.035-.1-.068-.2-.1-.3s-.063-.188-.093-.28a43.2,43.2,0,0,1-2.48-10.5c-.049-.4-.1-.814-.147-1.254.1.894.2,1.683.3,2.394h0c0-.047-.748-11.24-.617-12.5s.64-3.016,3.024-5.119a11.124,11.124,0,0,0,3.111-6.549,16.961,16.961,0,0,0,1.271-5.483V-140.1H204.6a49.139,49.139,0,0,1,1.112,10.022c0,1.447-.059,3.118-.2,5.088-.275,3.864-.869,20.3-.869,20.3h0a46.689,46.689,0,0,1,1.784,10.744c.224,6.067.291,12.016.291,12.016a6.864,6.864,0,0,1-2.756,1.856,7.458,7.458,0,0,1-2.784.505",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "M192.278-106.478l-.024-.212c-.464-4.2-1.083-9.3-1.559-13.138h0c.476,3.837,1.095,8.944,1.559,13.138l.024.212",
    transform: "translate(0 533.387)",
    fill: "#846f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path403",
    d: "M192.578-104.084c-.1-.711-.2-1.5-.3-2.394l-.024-.212c-.464-4.194-1.083-9.3-1.559-13.138q.422-.346.869-.693a17.421,17.421,0,0,0,6.531-7.729,11.124,11.124,0,0,1-3.111,6.549c-2.384,2.1-2.895,3.856-3.024,5.119s.616,12.452.617,12.5",
    transform: "translate(0 533.387)",
    fill: "#191b4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M179.561-80.2a2.158,2.158,0,0,1-.321,2.231,4.633,4.633,0,0,1-3.709,1.35,4.688,4.688,0,0,1-2.905-1.187c-.867-.672-1.475-1.258-1.8-1.537a9.574,9.574,0,0,0-2.843-.88c-1.291-.259-3.773-.8-5.036-2.643a5.356,5.356,0,0,1-1.044-3.455L179.561-80.2",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path405",
    d: "M170.076-87.487c2.64.907,6.652,1.46,9.044,2.095.719.668.563,3.7.571,5.744-.916,2.1-3.845,2.64-5.788,1.8-1.008-.555-1.68-1.339-2.671-1.944a7.923,7.923,0,0,0-2.547-.892,22.942,22.942,0,0,1-3.045-.916c-2.592-1.188-3.883-3.4-3.729-5.189.2-2.276,2.28-2.723,8.165-.7",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "M179.2-87.487l-.14,3.494s-.217.846-2.571,1.145a5.722,5.722,0,0,1-4.743-1.313s-.065-1.2-.2-2.376l7.657-.949",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path407",
    d: "M199.366-133.733a16.836,16.836,0,0,1-7.8,13.212,71.651,71.651,0,0,0-6.789,6.305c-2.728,2.7-5.219,5.336-5.219,5.336a22.83,22.83,0,0,1,.949,8.59c-.257,5.487-1.24,14.17-1.24,14.17a6.548,6.548,0,0,1-4.367,1.186,5.735,5.735,0,0,1-3.476-1.206s-2.748-20.151-3.091-23.494-.607-5.492,1.5-9.469c2.225-4.195,9.558-19.565,9.85-20.994h19.68v6.364",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "M175.494-84.9a5.928,5.928,0,0,1-.595-.028,5.735,5.735,0,0,1-3.476-1.206s-.265-1.944-.641-4.724l7.71,5.113h0l.089.059a6.646,6.646,0,0,1-3.088.786m7.67-27.7-6.677-4.428.143-2.313a.765.765,0,0,0-.309-.621l-4.529-3c3.029-6.146,7.664-16,7.894-17.126h19.68v6.364a16.961,16.961,0,0,1-1.271,5.483,17.421,17.421,0,0,1-6.531,7.729q-.448.348-.869.693h0c-2.225,1.831-3.967,3.678-5.92,5.612-.552.547-1.1,1.092-1.611,1.612m-8.626-5.721-3.8-2.522c.048-.1.1-.195.148-.294l3.347,2.219a.777.777,0,0,1,.309.591v.007",
    transform: "translate(0 533.387)",
    fill: "#2b2f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path409",
    d: "M188.471-174.228l.864,6.331,8.6-.437-.931-6.857-8.534.964",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "M184.247-185.555c-.6.885-2.455,3.305-2.773,3.925l2,1.032.769-4.957",
    transform: "translate(0 533.387)",
    fill: "#f57585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path411",
    d: "M188.569-192.243c-2.671-.1-4.257,1.9-4.629,7.6-.015.224-.317.593-.505,1.456-.807,3.7.032,7.1.709,7.976a7.41,7.41,0,0,0,5.821,1.08c1.875-.293,6.641-1.205,8.9-3.924,2.656-3.2,3.785-7.812,1.583-10.009-3.1-3.093-10.406-4.124-11.878-4.177",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M184.143-175.213a8.607,8.607,0,0,0,4.423,1.545l-.228-1.176a15.911,15.911,0,0,1-4.195-.369",
    transform: "translate(0 533.387)",
    fill: "#f57585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path413",
    d: "M188.745-182.319a.5.5,0,0,0,.895.084,6.569,6.569,0,0,1,.889-1.189,2.428,2.428,0,0,1,1.6-.669c2.237.012,1.9,2.981.881,4.079-1.669,1.8-2.721.421-2.721.421s-1.083,2.927.905,4.451c0,0,3.328,1.168,5.808.2a23.147,23.147,0,0,0,4.365-5.271c2.728-4.381,2.16-8.638.137-9.681l-.1-.887a4.431,4.431,0,0,0-.4-1.053,5.418,5.418,0,0,0-1.925-2.007,12.325,12.325,0,0,0-7.462-1.481,5.529,5.529,0,0,1-1.625-.029,1.65,1.65,0,0,1-1.224-.972,2.209,2.209,0,0,0-1.213,2.249,1.116,1.116,0,0,1-.807-.544c-.129-.225-.232-.537-.491-.56a.564.564,0,0,0-.425.239,3.763,3.763,0,0,0-.968,2.924,3.3,3.3,0,0,0,1.72,2.52c.459.232.968.345,1.436.559l.157.119-.011.28a2.907,2.907,0,0,0,.591,2.695l.119.191c.081.421-.287.983-.281,1.443.007.488.044.987.077,1.473a1.253,1.253,0,0,0,.077.417",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "M202.808-171.938c-3.531-.733-9.306.171-14.544,2.711-2.469,1.2-4.3,1.871-5.881,2.751s-2.319,4.117-2.488,6.605a125.423,125.423,0,0,0,0,13.87c.107,6.121-.34,7.777-.34,7.777s7.7,5.692,19.384,2.16c5.669-1.713,5.448-4.565,5.472-6.58s-.207-9.025,1.119-14.76,1.561-13.642-2.723-14.534",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path415",
    d: "M186.829-168.953c1.933-1.74,1.349-1.835,2.605-2.867,1.56-1.283,8.39-2.88,8.938-2.323a7.452,7.452,0,0,0,2.016,1.495s-.324,1.048-4.447,2.045c-3.933.952-5.488.82-9.113,1.649",
    transform: "translate(0 533.387)",
    fill: "#ececea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M199.912-172.886c-.247,1.972-7.673,3.471-12.252,3.533l-1.777.775a31.09,31.09,0,0,0-4.4,2.239c-.483.536-1.465,3-1.859,8.364-.229,3.119.116,10-.525,15.468a27.4,27.4,0,0,1-1.995,7.285s5.632,8.065,19.5,5.181a14.8,14.8,0,0,0,8.9-5.255s-.919-12.921-.673-15.12,2.175-11.473,1.96-15.12-.8-6.314-3.056-6.649a38.222,38.222,0,0,1-3.825-.7",
    transform: "translate(0 533.387)",
    fill: "#faf9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path417",
    d: "M186.827-109.36l-1.3,20.886c-.063,1.013-.815,1.553-1.723,2.014l-2.276,1.133a2.112,2.112,0,0,1-1.737.231,4.716,4.716,0,0,1-1.143-.553l-.044-.025-.115-.076-21.646-14.355a5.315,5.315,0,0,1-2.365-4.758l1.18-19.019a1.512,1.512,0,0,1,.757-1.139l3.883-1.929a1.489,1.489,0,0,1,1.36.085l24.554,16.285a1.377,1.377,0,0,1,.453.536,1.417,1.417,0,0,1,.159.684",
    transform: "translate(0 533.387)",
    fill: "#2e3e47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "M186.827-109.361l-1.3,20.887c-.063,1.013-.815,1.553-1.723,2.014l-2.276,1.133a2.112,2.112,0,0,1-1.737.231,4.716,4.716,0,0,1-1.143-.553v-.009c.849.465,1.567.052,1.631-.983l1.223-19.681a2.107,2.107,0,0,0-.239-1.036l5.4-2.687a1.416,1.416,0,0,1,.159.683",
    transform: "translate(0 533.387)",
    fill: "#1f2a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path419",
    d: "M181.507-106.321a2.293,2.293,0,0,0-.92-1.849l-23.209-15.391c-.917-.608-1.723-.208-1.792.891l-1.2,19.333a2.664,2.664,0,0,0,1.187,2.386l22.921,15.2c.917.608,1.724.208,1.792-.891l1.223-19.681",
    transform: "translate(0 533.387)",
    fill: "#3c515c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M159.043-126.325l24.59,16.461a2.4,2.4,0,0,1,1.056,2.135l-1.335,21.5-.4.2,1.348-21.722a2.009,2.009,0,0,0-.884-1.787l-24.774-16.583.4-.2",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path421",
    d: "M167.94-123.093l-.2,3.234-1.309.652.267-4.295c.013-.222.173-.3.359-.179l.885.587",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "M166.429-119.206l.267-4.295h0v-.008c0-.007,0-.012,0-.019.016-.132.088-.207.187-.209h.015a.286.286,0,0,1,.127.04l.005,0h0l.009.005h0s.007,0,.009.007h0l.885.587-.163,2.615-.028.451-.011.169-1.309.652",
    transform: "translate(0 533.387)",
    fill: "#784197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path423",
    d: "M176.63-119.345l-.325,5.237-1.251.625-.783-.521.267-4.3a.773.773,0,0,0-.309-.621l-5.941-3.938-1.233-.819c-.185-.122-.345-.044-.359.179l-.267,4.295-.787-.521.325-5.233.011-.068a.775.775,0,0,1,.375-.512l.533-.267a.772.772,0,0,1,.693.044l8.741,5.8a.765.765,0,0,1,.309.621",
    transform: "translate(0 533.387)",
    fill: "#9a59b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "M175.054-113.484l-.783-.521.267-4.3v-.031a.777.777,0,0,0-.309-.591l-5.941-3.938-.348-.232-.885-.587h0s-.007,0-.009-.007h0l-.009-.005h0l-.005,0a.286.286,0,0,0-.127-.04h-.015c-.1,0-.171.078-.187.209,0,.007,0,.012,0,.019v.008h0l-.267,4.295-.787-.521.325-5.233.011-.068a.192.192,0,0,1,.185-.168.306.306,0,0,1,.165.057l8.741,5.8a.773.773,0,0,1,.309.621l-.325,5.237",
    transform: "translate(0 533.387)",
    fill: "#8946a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path425",
    d: "M167.516-124.223c.853-2.432,1.207-3.473,1.7-5.2a28.072,28.072,0,0,0,1.431-6.208l6.221,1.9a27.863,27.863,0,0,0-1.151,4.973c-.215,1.626.229,3.24,0,4.831a3.808,3.808,0,0,1-.4,1.429c-.628,1.051-2.351,1.5-1.993,2.979l.9.6a.853.853,0,0,1,.295.84,1.729,1.729,0,0,1-.851.471,1.564,1.564,0,0,1-.417.036c-.143-.008-.3-.091-.437-.09s-.281.094-.439.092a1.883,1.883,0,0,1-.471-.079,1.555,1.555,0,0,1-.8-.392c-.2-.224-.264-.557-.5-.739-.328-.25-.8-.095-1.2-.149a1.179,1.179,0,0,1-.923-.716,1.409,1.409,0,0,0-.267-.569c-.163-.147-.405-.152-.6-.245a.957.957,0,0,1-.465-.594,5.16,5.16,0,0,1,.371-3.168",
    transform: "translate(0 533.387)",
    fill: "#f68c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M179.936-165.689a7.764,7.764,0,0,0-4.152,4.272c-1.189,2.8-1.819,6.421-2.633,10.69-.695,3.633-3.471,18.549-3.471,18.549A5.765,5.765,0,0,0,172.674-131a6.751,6.751,0,0,0,3.891-.3s3.075-10.5,3.983-13.272,4.02-10.242,4.02-10.242c1.2-4.915.393-10.248-1.872-12.268,0,0-1.671.817-2.76,1.395",
    transform: "translate(0 533.387)",
    fill: "#e7e7e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/aboutImg.a30a8bceda888fc586494230a677a90b.svg";
export { ForwardRef as ReactComponent };